const de = {
  // A7. Footer + cookie banner + register-flow consent
  footer: {
    impressum: 'Impressum',
    datenschutz: 'Datenschutz',
    agb: 'AGB',
    widerruf: 'Widerrufsrecht',
    faq: 'FAQ',
  },
  cookies: {
    bannerLabel: 'Cookie-Einstellungen',
    message: 'Wir verwenden technisch notwendige Cookies, damit du eingeloggt bleibst. Optional dürfen wir Sentry zur Fehlerdiagnose laden, wenn du zustimmst.',
    learnMore: 'Mehr erfahren',
    settings: 'Einstellungen',
    declineAll: 'Nur notwendige',
    acceptAll: 'Alle akzeptieren',
    settingsTitle: 'Cookie-Einstellungen',
    essential: 'Notwendig (immer aktiv)',
    essentialDesc: 'Login und Sitzungsverwaltung. Ohne diese funktioniert die App nicht.',
    analytics: 'Fehler-Monitoring (Sentry)',
    analyticsDesc: 'Hilft uns, Fehler in der App zu erkennen. Übermittelt anonymisierte Stack-Traces an Sentry.',
    marketing: 'Marketing',
    marketingDesc: 'Aktuell ungenutzt. Wenn wir später Pixel oder Werbe-Remarketing einsetzen, fragen wir hier.',
    saveChoices: 'Auswahl speichern',
  },
  // (auth.* keys merged below into the canonical block. This comment
  // marker is kept so future greps can find the consolidated home.)
  // A5. In-app banner that mirrors the preview email. Surfaces
  // pending renders waiting on the user's decision.
  pendingPreview: {
    // require_approval mode (silence == skip)
    singleTitle: 'Eine Vorschau wartet auf deine Freigabe',
    multiTitle: '{{count}} Vorschauen warten auf deine Freigabe',
    multiSubtitle: 'Wir haben deine Auto-Posts gerendert. Schau sie dir an, bevor sie raus gehen.',
    review: 'Vorschau ansehen',
    reviewNext: 'Nächste ansehen',
    // auto_with_preview mode (silence == post). The post fires anyway –
    // the banner is a kill-switch, not a gate. Copy must NOT imply
    // approval is needed; otherwise users panic and think they have to
    // open every preview before anything can post.
    autoSingleTitle: 'Vorschau für deinen geplanten Auto-Post',
    autoMultiTitle: '{{count}} Auto-Posts bereit zur Vorschau',
    autoSubtitleScheduled: 'Wird automatisch um {{time}} gepostet',
    autoSubtitleNoTime: 'Wird automatisch gepostet. Schau rein, wenn du etwas ändern willst.',
    autoMultiSubtitle: 'Werden automatisch gepostet. Reinschauen nur, wenn du etwas ändern oder stoppen willst.',
    autoReview: 'Anschauen oder stoppen',
    autoReviewNext: 'Nächsten ansehen',
  },
  // A5. Auto-post preview landing page (public, token-gated link)
  preview: {
    title: 'Auto-Post Vorschau',
    untitled: 'Deine Immobilie',
    scheduledFor: 'Geplant: {{date}}',
    captionLabel: 'Caption',
    approve: 'Posten freigeben',
    reject: 'Diesen Post abbrechen',
    stop: 'Diesen Post stoppen',
    noActionHelp: 'Wenn du nichts machst, posten wir das Video automatisch zur geplanten Zeit.',
    noActionHelpStrict: 'Ohne deine Freigabe wird dieser Post nicht veröffentlicht.',
    unsavedEdits: 'Du hast ungespeicherte Änderungen. „Freigeben" speichert automatisch.',
    unsavedEditsAuto: 'Du hast ungespeicherte Änderungen. Speichere sie, bevor das Video automatisch gepostet wird.',
    approvedTitle: 'Bestätigt. Wir posten zur geplanten Zeit',
    approvedHelp: 'Du kannst dieses Tab jetzt schließen. Bei Problemen findest du den Status im Dashboard.',
    rejectedTitle: 'Post abgebrochen',
    rejectedHelp: 'Wir überspringen diesen Slot. Morgen schicken wir dir einen neuen Vorschlag.',
    publishNow: 'Jetzt veröffentlichen',
    publishingNowTitle: 'Wird sofort veröffentlicht',
    publishingNowHelp: 'Wir posten dieses Video jetzt auf deinen verbundenen Plattformen. Den nächsten Auto-Post bekommst du wie gewohnt morgen per Email.',
    alreadyPostedTitle: 'Bereits gepostet',
    alreadyPostedHelp: 'Dieses Video wurde schon veröffentlicht. Du musst nichts mehr tun. Den nächsten Auto-Post bekommst du wie gewohnt per Email.',
    slotPassedTitle: 'Slot ist vorbei',
    slotPassedHelp: 'Dieser geplante Slot ist abgelaufen, ohne dass eine Bestätigung gekommen ist. Wir haben den Post übersprungen. Der nächste kommt morgen.',
    slotPassedTip: 'Tipp: Wechsle in den Einstellungen auf „Automatisch mit Vorschau", damit verpasste Bestätigungen den Post nicht mehr stoppen.',
    alreadyRejectedTitle: 'Bereits abgebrochen',
    alreadyRejectedHelp: 'Du hast diesen Post schon vorher abgebrochen. Er wird nicht mehr veröffentlicht. Morgen kommt der nächste Vorschlag.',
    renderFailedTitle: 'Render fehlgeschlagen',
    renderFailedHelp: 'Wir konnten dieses Video leider nicht erstellen. Wir versuchen es morgen mit einer anderen Immobilie. Falls das öfter passiert, melde dich bei support@real-content.at.',
    missingToken: 'Kein Token in der URL gefunden.',
    loadFailed: 'Vorschau konnte nicht geladen werden. Der Link ist abgelaufen oder ungültig.',
    actionFailed: 'Aktion fehlgeschlagen. Bitte später erneut versuchen.',
    videoUnavailable: 'Video noch nicht bereit. Versuch es in ein paar Minuten erneut.',
    // Navigation footer. Appears below every state so the user has
    // a way back to the app from this email-landing page. Was a dead
    // end before: every terminal card just said "you can close this
    // tab", with no link back.
    backToDashboard: 'Zum Dashboard',
    manageAutoPost: 'Auto-Post verwalten',
    signIn: 'Bei Real Content anmelden',
    // Fast-track edit / re-render from the preview page
    fastTrackTitle: 'Passt nicht? Video anpassen',
    optionsFailed: 'Optionen konnten nicht geladen werden.',
    rerenderStarted: 'Neues Video wird erstellt …',
    rerenderFailed: 'Neu erstellen fehlgeschlagen.',
    rerendering: 'Neues Video wird erstellt …',
    rerenderingHint: 'Das dauert meist unter einer Minute.',
    template: 'Vorlage',
    property: 'Immobilie',
    tooFewImages: 'zu wenige Bilder',
    imagesShort: 'Bilder',
    comboLoading: 'Bilder & Texte werden angepasst …',
    images: 'Bilder',
    imagesHint: 'Reihenfolge = Reihenfolge im Video.',
    imagesCountHint: 'Bitte genau {{count}} Bilder wählen.',
    onScreenText: 'Texte im Video',
    voiceoverScript: 'Sprechtext (Voiceover)',
    voiceoverPlaceholder: 'Was die KI-Stimme sagt …',
    voiceoverOn: 'An',
    voiceoverOffLabel: 'Aus',
    voiceoverOff: 'Kein Voiceover — das Video bekommt nur Hintergrundmusik.',
    music: 'Musik',
    musicAutomatic: 'Automatisch (aus deinen Favoriten)',
    applyEdits: 'Übernehmen & neu erstellen',
    differentPropertyHint: 'Diese Immobilie passt gar nicht?',
    differentProperty: 'Andere Immobilie',
  },
  // A4. Anti-abuse gating banner + verify-email landing page
  verify: {
    emailTitle: 'Bitte bestätige deine E-Mail-Adresse',
    emailHelp: 'Wir haben dir einen Bestätigungs-Link geschickt. Bis du klickst, kannst du keine Videos erstellen.',
    resend: 'Bestätigung erneut senden',
    resendSent: 'Wir haben dir eine neue Bestätigungs-E-Mail geschickt. Schau in dein Postfach (auch Spam).',
    resendThrottled: 'Zu viele Anfragen. Bitte warte ein paar Minuten und versuch es erneut.',
    resendFailed: 'Konnte die E-Mail nicht senden.',
    cardTitle: 'Karte hinterlegen. Kostenlos, keine Belastung',
    cardHelp: 'Wir prüfen nur kurz, ob die Karte echt ist (€0 Autorisierung). Es wird nichts abgebucht. Erst danach können wir dein erstes Video erstellen. So verhindern wir Missbrauch.',
    cardCta: 'Karte hinterlegen',
    cardSetupFailed: 'Konnte die Karten-Verifizierung nicht öffnen.',
  },
  verifyEmail: {
    verifying: 'Wird bestätigt…',
    verifyingHelp: 'Wir prüfen deinen Bestätigungslink. Gleich geht es weiter.',
    success: 'E-Mail bestätigt!',
    successHelp: 'Dein Account ist jetzt aktiv. Du kannst direkt loslegen.',
    errorTitle: 'Verifizierung fehlgeschlagen',
    errorHelp: 'Logge dich ein und klicke im Dashboard auf "Bestätigung erneut senden", um einen neuen Link zu bekommen.',
    failed: 'Verifizierung fehlgeschlagen. Der Link ist abgelaufen oder ungültig.',
    missingToken: 'Kein Token in der URL gefunden.',
    goToDashboard: 'Zum Dashboard',
    goToLogin: 'Zum Login',
  },
  common: {
    save: 'Speichern',
    cancel: 'Abbrechen',
    next: 'Weiter',
    back: 'Zurück',
    skip: 'Überspringen',
    loading: 'Laden...',
    saving: 'Speichere…',
    error: 'Fehler',
    success: 'Erfolgreich',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    close: 'Schließen',
    confirm: 'Bestätigen',
    logout: 'Abmelden',
    upgrade: 'Upgraden',
    toDashboard: 'Zum Dashboard',
    uploading: 'Lade hoch…',
    remove: 'Entfernen',
    retry: 'Erneut versuchen',
    refresh: 'Aktualisieren',
    search: 'Suchen',
    all: 'Alle',
    yes: 'Ja',
    no: 'Nein',
    or: 'oder',
    add: 'Hinzufügen',
    copy: 'Kopieren',
    copied: 'Kopiert',
    copyFailed: 'Konnte nicht kopieren.',
    connect: 'Verbinden',
    connected: 'Verbunden',
    notConnected: 'Nicht verbunden',
    activate: 'Aktivieren',
    deactivate: 'Deaktivieren',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    configure: 'Konfigurieren',
    generate: 'Generieren',
    import: 'Importieren',
    upload: 'Hochladen',
    settings: 'Einstellungen',
    details: 'Details',
    status: 'Status',
  },
  nav: {
    dashboard: 'Dashboard',
    autoPost: 'Auto Post',
    properties: 'Immobilien',
    profile: 'Profil',
    social: 'Social Media',
    videos: 'Videos',
    subscription: 'Abo',
    justimmo: 'Justimmo',
    imports: 'Datenquellen',
    language: 'Sprache',
    team: 'Team',
    // Section headers in the mobile drawer
    primary: 'Hauptmenü',
    secondary: 'Konto & Tools',
    // aria-labels for icon-only nav buttons (mobile)
    openMenu: 'Menü öffnen',
    closeMenu: 'Menü schließen',
    logoToDashboard: 'Real Content. Zur Übersicht',
    studio: 'KI-Studio',
    soon: 'Bald',
  },
  // KI-Studio teaser page (/studio). The studio is not live yet.
  studio: {
    kicker: 'Bald verfügbar',
    title: 'KI-Studio',
    subtitle: 'Mach mehr aus deinen Inseratsfotos: Fotos verbessern, aus einem Foto einen kurzen Clip machen und selbst entscheiden, was davon in dein Video kommt.',
    demoTitle: 'Aus einem Foto wird ein Clip',
    demoPhoto: 'Inseratsfoto',
    demoClip: 'KI-Clip, 5 Sekunden',
    demoNote: 'Beispiel aus unseren Tests. Deine eigenen Ergebnisse siehst du immer zuerst als Vorschau.',
    feature1Title: 'Fotos verbessern',
    feature1Body: 'Licht, Farben und Schärfe in Sekunden korrigiert, damit jeder Raum so hell wirkt, wie er wirklich ist.',
    feature2Title: 'Clips aus Fotos',
    feature2Body: 'Ein Standbild wird zur ruhigen Kamerafahrt im Hochformat. Ideal als Einstieg für Reels und TikTok.',
    feature3Title: 'Du behältst die Kontrolle',
    feature3Body: 'Nichts passiert automatisch. Du siehst jedes Ergebnis zuerst und entscheidest, ob es verwendet wird.',
    pricingNote: 'In den Abos ist ein monatliches Kontingent enthalten. Wenn du mehr brauchst, kaufst du einfach nach.',
    ctaTitle: 'Früh testen?',
    ctaBody: 'Wir suchen Makler, die das KI-Studio vor dem Start ausprobieren und uns sagen, was sie wirklich brauchen.',
    ctaButton: 'Ich will früh testen',
    ctaDone: 'Du bist auf der Liste. Wir melden uns per Mail, sobald du testen kannst.',
    ctaToast: 'Danke, du bist auf der Liste.',
    ctaError: 'Das hat nicht geklappt. Bitte versuch es nochmal.',
  },
  freeTier: {
    label: 'Free Plan',
    videosUsed: '{{count}} / {{max}} Videos genutzt',
    upgradeUnlimited: 'Auf Autopilot upgraden',
  },
  starterTier: {
    label: 'Starter',
    videosUsed: 'Diesen Monat: {{count}} / {{max}} Videos',
    upgradeCta: 'Auf Autopilot upgraden',
  },
  // Generated-video card on the property page (per-render result)
  videoCard: {
    unknownTemplate: 'Unbekannte Vorlage',
    captionCopied: 'Caption kopiert',
    copyFailed: 'Konnte nicht kopieren',
    copyAria: 'Caption kopieren',
    copyMenuHint: 'Pro Plattform passende Caption kopieren',
    copyForPlatform: 'Kopieren für…',
  },
  auth: {
    welcomeBack: 'Willkommen zurück',
    signIn: 'Anmelden',
    signUp: 'Registrieren',
    signInSubtitle: 'Melden Sie sich bei Ihrem Konto an',
    signUpSubtitle: 'Erstellen Sie Ihr Konto',
    email: 'E-Mail',
    password: 'Passwort',
    fullName: 'Vollständiger Name',
    noAccount: 'Noch kein Konto?',
    hasAccount: 'Bereits ein Konto?',
    loginSuccess: 'Willkommen zurück!',
    registerSuccess: 'Konto erfolgreich erstellt!',
    logoutSuccess: 'Erfolgreich abgemeldet',
    authFailed: 'Authentifizierung fehlgeschlagen',
    // A7. DSGVO consent block on register form. Each fragment renders
    // around inline links to /agb and /datenschutz, so kept short.
    termsConsentPrefix: 'Ich habe die',
    termsLink: 'AGB',
    termsAnd: 'und die',
    privacyLink: 'Datenschutzerklärung',
    termsConsentSuffix: 'gelesen und akzeptiere sie.',
    acceptTermsRequired: 'Bitte akzeptiere AGB und Datenschutzerklärung.',
    // Tagline + logo aria-label on the auth page.
    tagline: 'Social Media für Makler. Automatisch',
    logoToHome: 'Real Content. Zur Startseite',
    // Inline password-policy feedback on the Sign-Up form.
    passwordRuleLength: 'Mind. 10 Zeichen',
    passwordRuleLetter: 'Ein Buchstabe',
    passwordRuleDigit: 'Eine Ziffer',
    passwordMissing: 'Dein Passwort braucht noch: {{rules}}.',
    // Show/hide-password toggle (eye icon inside the input). aria-only;
    // no visible text. The icon flips between Eye / EyeOff.
    showPassword: 'Passwort anzeigen',
    hidePassword: 'Passwort verbergen',
    // Form-field placeholders (separate key so we can localise the
    // example name without touching the label).
    fullNamePlaceholder: 'Max Mustermann',
    // ── Forgot-password sub-flow on AuthPage ──────────────────────
    forgotLink: 'Passwort vergessen?',
    forgotTitle: 'Passwort vergessen',
    forgotSubtitle: 'Wir schicken dir einen Link zum Zurücksetzen.',
    forgotSubmit: 'Reset-Link anfordern',
    forgotSentSubtitle: 'Schau in dein E-Mail-Postfach.',
    forgotSentBody: 'Falls ein Konto mit dieser E-Mail existiert, haben wir dir einen Link zum Zurücksetzen geschickt. Der Link ist 30 Minuten gültig.',
    forgotSentHint: 'Keine E-Mail erhalten? Schau im Spam-Ordner nach oder versuche es in ein paar Minuten erneut.',
    forgotRateLimit: 'Zu viele Anfragen. Bitte warte eine Stunde und versuche es erneut.',
    backToLogin: 'Zurück zur Anmeldung',
  },
  // /reset-password page. Consumes the token from the email link
  // and lets the user set a new password.
  resetPassword: {
    title: 'Neues Passwort wählen',
    subtitle: 'Wähle ein neues Passwort für dein Konto. Du wirst danach zur Anmeldung weitergeleitet.',
    newPasswordLabel: 'Neues Passwort',
    confirmLabel: 'Passwort bestätigen',
    mismatch: 'Die Passwörter stimmen nicht überein.',
    submit: 'Passwort speichern',
    submitting: 'Wird gespeichert…',
    successTitle: 'Passwort geändert',
    successBody: 'Du kannst dich jetzt mit deinem neuen Passwort anmelden.',
    successToast: 'Passwort geändert.',
    toLogin: 'Zur Anmeldung',
    errorTitle: 'Link ungültig oder abgelaufen',
    errorBody: 'Bitte fordere einen neuen Link an.',
    failed: 'Etwas ist schiefgelaufen. Versuche es erneut.',
    missingToken: 'Kein Token in der URL gefunden.',
    requestNew: 'Neuen Link anfordern',
  },
  // Illustrated step-by-step Justimmo Export-API setup guide. Used by
  // both the onboarding ImportStep and the standalone JustimmoPage.
  justimmoGuide: {
    title: 'Schritt-für-Schritt-Anleitung anzeigen',
    subtitle: '8 Screenshots aus Justimmo. Dauert ca. 3 Minuten.',
    adminWarning: 'Hinweis: Du brauchst Administrator-Rechte in Justimmo, sonst siehst du den Punkt „Exporte" nicht.',
    footer: 'Klick auf ein Bild, um es in voller Größe in einem neuen Tab zu öffnen.',
    steps: {
      menu: {
        title: 'In der Navigation auf „Mehr" klicken',
        body: 'Login als Administrator. In der oberen Navigationsleiste den Menüpunkt „Mehr" öffnen.',
      },
      exports: {
        title: '„Exporte" auswählen',
        body: 'Im Untermenü zu „Exporte" navigieren. Hier landen alle externen Anbindungen.',
      },
      create: {
        title: '„API erstellen" klicken',
        body: 'Rechts oben den Button „API erstellen" anklicken, um einen neuen API-Zugang anzulegen.',
      },
      autoAdd: {
        title: '„Neue Objekte automatisch hinzufügen" aktivieren',
        body: 'Damit jede neue Immobilie ohne extra Klick in Real Content landet, diese Option einschalten. Wenn du lieber pro Objekt entscheidest, lass sie aus.',
      },
      category: {
        title: 'Kategorie „Sonstiges", Name + E-Mail eintragen, „Speichern"',
        body: 'Kategorie auf „Sonstiges" stellen, einen sprechenden Namen wie „Real Content" und deine E-Mail eintragen, dann speichern.',
      },
      open: {
        title: 'Den neu erstellten „JUSTIMMO API"-Eintrag öffnen',
        body: 'In der Liste den frisch angelegten Eintrag anklicken, um Benutzer und Passwort zu sehen.',
      },
      creds: {
        title: 'Benutzer & Passwort hier in Real Content eintragen',
        body: 'Beide Werte kopieren und unten in die Felder eintragen. Anschließend „Verbinden" klicken.',
      },
      enable: {
        title: 'Pro Objekt: „Vermarktung" → ganz unten „Justimmo API" anhaken',
        body: 'Wenn keine Listings auftauchen: in jeder Immobilie unter „Vermarktung" runterscrollen und die Checkbox „Justimmo API" setzen. Mit aktivem Auto-Hinzufügen passiert das für neue Objekte automatisch.',
      },
    },
  },
  onboarding: {
    welcome: 'Willkommen bei Real Content',
    subtitle: 'In wenigen Schritten zu automatischen Social-Media-Posts',
    letsGo: 'Los geht\'s',
    stepOf: 'Schritt {{current}} von {{total}}',
    // Toast errors when WelcomeStep loads / saves the user profile.
    profileLoadFailed: 'Profil konnte nicht geladen werden.',
    profileSaveFailed: 'Profil konnte nicht gespeichert werden.',
    step1: {
      title: 'Profil',
      subtitle: 'Diese Informationen erscheinen in Ihren Videos',
      name: 'Ihr Name',
      namePlaceholder: 'Max Mustermann',
      brandName: 'Firmenname',
      brandPlaceholder: 'Mustermann Immobilien',
      phone: 'Telefonnummer',
      phonePlaceholder: '+43 1 234 5678',
      photo: 'Ihr Foto',
      photoDesc: 'Erscheint im Abspann jedes Videos. Ohne Foto nutzen wir einen Platzhalter.',
      logo: 'Firmenlogo',
      logoDesc: 'Erscheint im Abspann jedes Videos.',
      optionalHeading: 'Für persönlichere Videos (empfohlen)',
      optionalHint: 'Ohne diese Daten nutzen wir Platzhalter im Abspann.',
      optionalTag: 'optional',
      photoRecommended: 'Empfohlen. Sonst Platzhalter',
    },
    step2: {
      title: 'Immobilien',
      subtitle: 'Verbinden Sie Justimmo oder fügen Sie Immobilien manuell hinzu',
      justimmoTitle: 'Justimmo Export verbinden',
      username: 'API Benutzername',
      password: 'API Passwort',
      connectButton: 'Verbinden',
      connected: 'Justimmo verbunden',
      importAll: 'Alle importieren',
      importSelected: '{{count}} importieren',
      importing: 'Wird importiert...',
      imported: '{{count}} Immobilien importiert',
      noProperties: 'Keine Immobilien gefunden',
      skipManual: 'Überspringen - später manuell hinzufügen',
      propertiesFound: '{{count}} Immobilien gefunden',
      loadFailed: 'Immobilien konnten nicht geladen werden',
      enterCredentials: 'Bitte Benutzername und Passwort eingeben',
      connectionFailed: 'Verbindung fehlgeschlagen',
      alreadyImported: 'Immobilie bereits importiert',
      importedSingle: 'Importiert: {{title}}',
      importFailed: 'Import fehlgeschlagen',
      inst1: 'Justimmo als Administrator einloggen',
      inst2: 'Unter "Mehr" \u2192 "Exporte" navigieren',
      inst3: 'Reiter "Benutzerdefinierte Exporte" wählen',
      inst4: '"Neuen API-Export erstellen" klicken',
      inst5: 'Benutzername und Passwort kopieren',
      // Agent picker. Multi-tenant safety, mandatory before listing
      // properties so we never import a colleague's listing under your name.
      agentPickerTitle: 'Welcher Makler bist du?',
      agentPickerHelp: 'Justimmo gibt uns alle Immobilien deiner Agentur. Wähle dich hier aus, damit wir nur deine Listings importieren. Niemals die deiner Kollegen.',
      agentPickerPlaceholder: 'Bitte auswählen…',
      agentPicked: 'Profil gespeichert. Wir zeigen dir nur deine eigenen Listings.',
      agentBackfilled: '{{count}} bestehende Immobilien deinem Profil zugeordnet.',
      agentPickFailed: 'Konnte dein Profil nicht speichern.',
      pickAgentFirst: 'Wähle dich oben aus der Mitarbeiterliste, um deine Immobilien zu sehen.',
      teamEmpty: 'Wir konnten die Mitarbeiterliste nicht laden. Stelle sicher, dass dein Justimmo-API-Account die "team/list"-Berechtigung hat, oder schreib uns kurz.',
    },
    // Step 3: swipe like/dislike on templates rendered against the user's
    // first property. Used by `SampleSwipeStep.js`.
    step3: {
      title: 'Stil wählen',
      subtitle: 'Jede Vorlage wurde mit deinen Fotos gerendert. Like die, die dir gefallen. Wir nutzen sie für deine Auto-Posts.',
      preparing: 'Deine Vorlagen werden gerendert…',
      preparingDesc: 'Wir erstellen parallel für jede Vorlage ein Beispiel mit deinen Fotos. Das erste ist in ein bis zwei Minuten fertig. Du kannst sofort swipen.',
      noPropertyTitle: 'Noch keine Immobilie',
      noPropertyBody: 'Importiere zuerst eine Immobilie im vorherigen Schritt, damit wir echte Vorschauen rendern können.',
      fewPhotosTitle: 'Zu wenig Fotos',
      fewPhotosBody: 'Deine Immobilie hat zu wenige Fotos, um Vorlagen zu sampeln. Füge ein paar mehr hinzu und komm zurück.',
      startFailedTitle: 'Konnte nicht starten',
      startFailedBody: 'Wir konnten die Beispielrenders nicht anstoßen. Probiere es bitte gleich nochmal.',
      alreadyDone: 'Du hast das Onboarding bereits abgeschlossen.',
      freeTierBanner: 'Du testest 5 Vorlagen. Upgrade, um alle 15 zu sehen.',
      skipStep: 'Diesen Schritt überspringen',
      doneTitle: 'Fertig geswipt!',
      doneSubtitle: 'Du hast {{count}} Vorlagen geliked. Wir nehmen die für deine Auto-Posts.',
      noLikesHint: 'Keine Sorge. Wenn du nichts likst, wählt unsere KI automatisch eine passende Vorlage pro Auto-Post aus. Du kannst später jederzeit ändern, welche Vorlagen du magst.',
      ofReady: 'von',
      readyLabel: 'Vorlagen gerendert',
      renderingHint: 'Du kannst schon swipen, die anderen kommen nach.',
    },
    // Step 4: background music selection (`MusicStep.js`).
    step4: {
      title: 'Wähle deine Musik',
      subtitle: 'Wir spielen diese im Hintergrund deiner Auto-Posts. Du kannst später jederzeit wechseln.',
      // Multi-select variant of the subtitle. Used when the user can
      // like multiple presets and we'll randomise per post.
      subtitleMulti: 'Like alles was dir gefällt. Wir spielen pro Auto-Post zufällig eine deiner Lieblingsmusiken.',
      selectedCount: '{{count}} ausgewählt',
      play: 'Anhören',
      pause: 'Pause',
      playFailed: 'Kann das Vorschau-Audio nicht abspielen.',
      loadError: 'Presets konnten nicht geladen werden. Du kannst deine eigene Musik hochladen oder den Schritt überspringen.',
      uploadTitle: 'Eigene Musik verwenden',
      uploadSubtitle: 'MP3-Datei hochladen, wenn du eine bestimmte Brand-Musik hast.',
      // Multi-select variant: uploaded MP3 joins the random rotation.
      uploadSubtitleMulti: 'MP3 hochladen. Wird zur zufälligen Auswahl dazugepackt.',
      uploadBtn: 'Hochladen',
      uploadSuccess: 'Eigene Musik hochgeladen',
      uploadFailed: 'Upload fehlgeschlagen. Bitte erneut versuchen.',
      noMusic: 'Keine Musik verwenden',
    },
    // Step 5: AI voiceover yes/no (`VoiceoverStep.js`).
    step5: {
      title: 'KI-Stimme verwenden?',
      subtitle: 'Du hast die Stimme gerade in den Beispielen gehört. Willst du sie auf deinen Auto-Posts behalten?',
      subtitleWithPreview: 'Hör kurz rein, wie die KI-Stimme klingt. Dann entscheide, ob sie auf deine Auto-Posts soll.',
      tapToHear: 'Stimme anhören',
      muted: 'Leise stellen',
      yesTitle: 'Ja, KI-Stimme behalten',
      yesBody: 'Wir sprechen deine Immobilien automatisch mit deinem Namen und Markennamen. Gut für Neuheiten-Posts.',
      noTitle: 'Lieber nur Musik',
      noBody: 'Kein Voiceover. Posts sind ruhiger und wirken oft auf TikTok/Reels natürlicher.',
      footer: 'Du kannst diese Einstellung jederzeit in den Auto-Post-Optionen ändern.',
      // Voice picker (only renders when "yes" is selected).
      voicePickerTitle: 'Stimme wählen',
      voicePickerHint: 'Halten zum Anhören',
      playSample: 'Probe',
      stop: 'Stopp',
      holdToHear: 'Halten zum Anhören',
      holding: 'Halten…',
      // Advanced expander. Power-users paste their own ElevenLabs voice_id.
      advancedTitle: 'Erweitert: Eigene Stimme',
      advancedHelp: 'Hast du eine eigene ElevenLabs-Stimme (z.B. einen Voice-Clone)? Füge die voice_id hier ein, um sie zu verwenden.',
      advancedFootnote: 'Du findest die voice_id im ElevenLabs Voice Library Dashboard.',
    },
    // Step 6: connect social accounts (moved up from old step 5).
    step6: {
      title: 'Social Media',
      subtitle: 'Verbinden Sie Ihre Konten für automatisches Posten',
      subtitleAll: 'Verbinde alle Konten, auf denen deine Auto-Posts erscheinen sollen. Instagram, Facebook, TikTok, YouTube, X und LinkedIn.',
      connectInstagram: 'Instagram verbinden',
      connectFacebook: 'Facebook verbinden',
      connectAll: 'Konten verbinden',
      connectDesc: 'Klicken Sie auf Verbinden, um Ihre Instagram-, Facebook-, TikTok-, YouTube-, X- und LinkedIn-Konten zu verknüpfen',
      connectedAccounts: '{{count}} Konto(s) verbunden',
      popupBlocked: 'Popup wurde blockiert. Bitte erlauben Sie Popups für diese Seite.',
    },
    // Step 7: activate auto-post (moved up from old step 6).
    step7: {
      title: 'Aktivieren',
      subtitle: 'Konfigurieren Sie Ihren automatischen Posting-Plan',
      postsPerDay: 'Posts pro Tag',
      preferredTime: 'Bevorzugte Uhrzeit',
      timezone: 'Zeitzone',
      summary: 'Zusammenfassung',
      summaryProfile: 'Profil eingerichtet',
      summaryProperties: '{{count}} Immobilien',
      summaryTemplates: '{{count}} Favoriten-Templates',
      summarySocials: '{{count}} Plattform(en) verbunden',
      activateAutoPost: 'Auto Post jetzt aktivieren',
      skipActivation: 'Später aktivieren',
      congratulations: 'Alles eingerichtet!',
      congDesc: 'Ihr Auto-Modus ist bereit. Real Content erstellt und postet Videos automatisch.',
      activated: 'Auto Post aktiviert!',
      activationFailed: 'Aktivierung fehlgeschlagen',
      goToDashboard: 'Zum Dashboard',
    },
  },
  dashboard: {
    title: 'Dashboard',
    autoPostStatus: 'Auto Post Status',
    autoPostActive: 'Auto Post Aktiv',
    autoPostInactive: 'Auto Post Inaktiv',
    configure: 'Konfigurieren',
    nextPost: 'Nächster Post',
    postsPerDay: '{{count}} Video(s) pro Tag um {{time}} Uhr',
    noPostsScheduled: 'Keine Posts geplant',
    stats: {
      properties: 'Immobilien',
      videos: 'Videos erstellt',
      platforms: 'Plattformen',
      weeklyPosts: 'Posts diese Woche',
    },
    recentPosts: 'Letzte Posts',
    viewAll: 'Alle anzeigen',
    noRecentPosts: 'Noch keine Posts',
    queue: 'Warteschlange',
    generateNow: 'Jetzt generieren',
    queueEmpty: 'Keine geplanten Posts',
    queueCount: '{{count}} Posts geplant',
    loadFailed: 'Dashboard konnte nicht geladen werden',
    setupRequired: 'Einrichtung erforderlich',
    setupDesc: 'Schließen Sie die Einrichtung ab, um automatisch zu posten.',
    startSetup: 'Einrichtung starten',
  },
  autoPost: {
    title: 'Auto Post Modus',
    subtitle: 'Automatisches tägliches Posten konfigurieren',
    modeRecommended: 'Empfohlen',
    sourcesTitle: 'Datenquellen',
    sourcesDesc: 'Auto-Post nutzt deine importierten Immobilien. Verwalte die Quellen unter „Datenquellen".',
    noSourcesYet: 'Noch keine Quelle verbunden',
    manageSources: 'Verwalten',
    connectSource: 'Quelle verbinden',
    enableWithoutProperties: 'Du brauchst mindestens eine Immobilie. Verbinde Justimmo oder Willhaben unter „Datenquellen".',
    // Skip-reason banner. Surfaces "why didn't yesterday's auto-post fire"
    // (audit #28). Reason codes come from scheduler_service._stamp_skip_reason.
    skipBanner: {
      title: 'Letzter Auto-Post übersprungen',
      noProperties: 'Keine geeigneten Immobilien gefunden. Stelle sicher, dass dein Justimmo- oder Willhaben-Filter auf dich selbst zeigt.',
      insufficientImages: '„{{title}}" hat nur {{have}} Bilder, gewählte Vorlage braucht {{need}}. Mehr Bilder hinzufügen oder andere Vorlage als Favorit setzen.',
      generic: 'Auto-Post konnte nicht erstellt werden. Schau die Queue-Liste unten an.',
    },
    // Music section on the AutoPost settings page. Mirrors the onboarding
    // MusicStep semantics: multi-select preset cards + optional MP3
    // upload, scheduler picks one at random per render.
    music: {
      title: 'Hintergrundmusik',
      subtitle: 'Wähle deine Lieblings-Tracks. Pro Auto-Post spielen wir zufällig einen davon. So klingt nicht jedes Video gleich.',
      selectedCount: '{{count}} ausgewählt',
      play: 'Anhören',
      pause: 'Pause',
      playFailed: 'Vorschau-Audio konnte nicht abgespielt werden.',
      loadError: 'Presets konnten nicht geladen werden. Lade die Seite neu oder lade eine eigene Datei hoch.',
      uploadTitle: 'Eigene Musik hinzufügen',
      uploadSubtitle: 'MP3 hochladen. Wird zur zufälligen Auswahl dazugepackt.',
      uploadBtn: 'MP3 hochladen',
      uploadSuccess: 'Eigene Musik hochgeladen.',
      uploadFailed: 'Upload fehlgeschlagen. Bitte erneut versuchen.',
      clearAll: 'Keine Musik verwenden',
    },
    // Caption style. Phase 1-3 of the caption-quality work. The full
    // panel lives in CaptionStyleSection.js; this controls tone, CTA
    // direction, hashtag aggression, emoji density, custom hashtags
    // (always/never), free-form instructions, and the Brand Voice
    // Analyzer that lets the AI learn the user's writing style.
    captionStyle: {
      title: 'Caption-Stil',
      subtitle: 'Wie soll die KI deine Captions schreiben? Jede Plattform bekommt eine eigene Variante.',
      preview: 'Vorschau',
      toneLabel: 'Tonfall',
      toneHint: 'Beeinflusst die Stimme der KI quer über alle Plattformen.',
      tone: {
        professional: 'Professionell',
        casual:       'Locker',
        luxury:       'Luxus',
        friendly:     'Freundlich-lokal',
      },
      ctaLabel: 'Call-to-Action',
      ctaHint: 'Engagement (Tag/Save/Kommentar) schlägt Website-Klicks bei Reichweite.',
      cta: {
        engagement: 'Engagement (Tag, Save, DM)',
        website:    'Website / Profil',
        dm:         'Direktnachricht',
      },
      hashtagLabel: 'Hashtag-Menge',
      hashtagHint: 'Mehr ≠ besser. „Standard" basiert auf 2026 Research-Empfehlungen.',
      aggression: {
        conservative: 'Sparsam',
        standard:     'Standard',
        aggressive:   'Maximal',
      },
      emojiLabel: 'Emoji-Dichte',
      emojiHint: 'LinkedIn bekommt sowieso nie Emojis. Egal was hier steht.',
      emoji: {
        none:     'Keine',
        sparing:  'Sparsam',
        moderate: 'Moderat',
        generous: 'Verspielt',
      },
      voiceTitle: 'Bring der KI deinen Schreibstil bei',
      voiceLearned: 'Schreibstil gespeichert',
      voiceHint: 'Wir schauen uns deine bisherigen Social-Posts an und schreiben zukünftige Captions in deinem Stil. Wortwahl, Tonfall, typische Strukturen.',
      voiceAnalyze: 'Stil analysieren',
      voiceUpdate: 'Neu analysieren',
      voiceClear: 'Schreibstil zurücksetzen',
      advancedToggle: 'Erweitert (Hashtags, eigene Anweisungen)',
      customTagsLabel: 'Immer einfügen',
      customTagsHint: 'Deine Branded-Tags oder Stadt-Tags die jeder Post bekommen soll.',
      customTagsPlaceholder: '#MeineMarke',
      blockedTagsLabel: 'Nie verwenden',
      blockedTagsHint: 'Tags die die KI generieren könnte, du aber nicht willst.',
      blockedTagsPlaceholder: '#TagDenIchNichtMag',
      customInstructionsLabel: 'Eigene Anweisungen',
      customInstructionsHint: 'Wird in jeden KI-Prompt eingefügt. Beispiel: „Erwähne immer den Energieausweis-Status".',
      customInstructionsPlaceholder: 'z.B. „Vermeide Buzzwords wie exklusiv oder einmalig. Erwähne immer dass Hund erlaubt ist."',
    },
    // Brand Voice Analyzer modal. Lets the user paste past posts (or
    // auto-import from connected socials) so the AI can synthesize a
    // writing-style profile for future captions.
    brandVoice: {
      title: 'Schreibstil analysieren',
      why: 'KI-Captions klingen ohne Anpassung für alle gleich. Gib uns ein paar deiner bisherigen Posts (oder importiere sie automatisch aus deinem verbundenen Profil) und wir schreiben zukünftige Captions in deinem Stil. Wortwahl, Tonfall, typische Strukturen.',
      // Auto-import from connected social profile
      autoImportBtn: 'Aus Social-Profil importieren',
      autoImportRunning: 'Importiere deine Posts…',
      autoImportFailed: 'Auto-Import fehlgeschlagen. Verbinde ein Social-Konto unter „Social Media" oder füge Posts manuell ein.',
      autoImportNotEnough: 'Wir haben in deinem Profil nicht genug verwertbare Posts gefunden. Bitte manuell einfügen.',
      autoImportNoSocial: 'Verbinde zuerst ein Social-Profil unter „Social Media", damit wir deine Posts importieren können.',
      autoImportSuccess: '{{count}} Posts aus {{platforms}} importiert.',
      orPasteManually: 'Oder Posts manuell einfügen:',
      captionsLabel: 'Deine bisherigen Posts (3–10)',
      captionsHint: 'Trenne die Posts mit einer Leerzeile oder „---". Captions, Tweets, LinkedIn-Posts. Alles was deinen Stil zeigt.',
      captionsPlaceholder: 'Beispiel:\n\nSchöne 3-Zimmer-Wohnung in Wien-Hietzing! Tag mir gerne jemanden in den Kommentaren, der für die nächste Bleibe Lust auf Stadtleben hat.\n\n---\n\nGerade gefunden: Altbau in Mariahilf mit Stuck und 3 m Decken. Für mich der Hammer. Schnell sein. Die Vermarktung läuft.',
      zero: 'Noch keine Posts erkannt.',
      detected: '{{count}} Posts erkannt.',
      needMore: 'Mindestens 2 Posts.',
      languageLabel: 'Sprache der Analyse:',
      analyze: 'Stil analysieren',
      analyzing: 'Analysiere…',
      analyzeFailed: 'Analyse fehlgeschlagen. Bitte später nochmal versuchen.',
      notEnough: 'Konnte nicht genug Muster erkennen. Mehr Posts hinzufügen?',
      currentlyLearned: 'Aktuell gespeichert:',
      replaceHint: 'Eine neue Analyse ersetzt den aktuellen Stil. Wenn du nur tweaken willst, brich ab.',
      gotIt: 'Das ist dein Stil:',
      tone: 'Tonfall',
      hookStyle: 'Hook-Stil',
      ctaStyle: 'CTA-Stil',
      structure: 'Aufbau',
      signaturePhrases: 'Wiederkehrende Formulierungen',
      avoid: 'Vermeidest du',
      emojiDensity: 'Emoji-Nutzung',
      summary: 'Zusammenfassung',
      editFields: 'Felder bearbeiten',
      editHint: 'Die KI hat den Stil aus deinen Posts gelesen. Kannst alles tweaken, bevor du es übernimmst.',
      addPhrase: 'Formulierung hinzufügen',
      addAvoid: 'Vermeidung hinzufügen',
      retry: 'Andere Posts',
      accept: 'Übernehmen',
      acceptHint: 'Wird automatisch gespeichert. Du musst oben nicht extra auf Speichern klicken.',
      saved: 'Dein Schreibstil ist jetzt aktiv für zukünftige Captions.',
    },
    // Caption preview modal. Lets the user see per-platform captions
    // for one of their properties under current settings.
    preview: {
      title: 'Caption-Vorschau pro Plattform',
      why: 'So sehen deine Captions auf jeder Plattform aus. Mit deinen aktuellen Stil-Einstellungen. Probier verschiedene Immobilien, optimiere die Einstellungen, sieh sofort das Ergebnis.',
      noProperties: 'Keine Immobilien vorhanden',
      placeholder: 'Wähle eine Immobilie und klick „Vorschau erstellen", um die Captions zu sehen.',
      generate: 'Vorschau erstellen',
      regenerate: 'Neu generieren',
      generating: 'Wird generiert…',
      failed: 'Vorschau konnte nicht generiert werden. Bitte erneut versuchen.',
      // Empty state when user has zero properties to preview against
      emptyTitle: 'Erst eine Immobilie hinzufügen',
      emptyHint: 'Caption-Vorschau braucht eine Immobilie als Vorlage. Verbinde Justimmo, importiere von Willhaben oder leg eine manuell an.',
      emptyCta: 'Zu meinen Immobilien',
    },
    enabled: 'Auto Post Aktiv',
    disabled: 'Auto Post Inaktiv',
    enabledDesc: '{{count}} Video(s) pro Tag um {{time}}',
    disabledDesc: 'Aktivieren für automatisches Posten',
    schedule: 'Zeitplan',
    scheduleDesc: 'Wann sollen Posts veröffentlicht werden?',
    time: 'Uhrzeit',
    timezone: 'Zeitzone',
    language: 'Sprache',
    platforms: 'Plattformen',
    platformsDesc: 'Wo sollen Posts veröffentlicht werden?',
    minOnePlatform: 'Mindestens eine Plattform muss ausgewählt sein',
    templates: 'Favoriten-Templates',
    templatesDesc: 'KI bevorzugt diese Templates bei der automatischen Auswahl',
    templatesDescManual: 'Templates für Auto-Posting auswählen',
    autoSelectTemplate: 'KI wählt bestes Template automatisch',
    aiSettings: 'KI-Einstellungen',
    aiSettingsDesc: 'KI-Inhaltsgenerierung konfigurieren',
    autoCaptions: 'Captions automatisch generieren',
    autoCaptionsDesc: 'KI schreibt ansprechende Captions für jeden Post',
    autoHashtags: 'Hashtags automatisch generieren',
    autoHashtagsDesc: 'KI fügt relevante Hashtags für mehr Reichweite hinzu',
    enableVoiceover: 'KI-Voiceover aktivieren',
    enableVoiceoverDesc: 'KI spricht einen Text im Video ein (wenn vom Template unterstützt)',
    // A5. Preview mode (3 options, guided progression)
    previewModeLabel: 'Vorschau-Modus',
    previewModeIntroTitle: 'Wie wollen wir posten?',
    previewModeIntroDesc: 'Wir empfehlen: Starte mit "Bestätigung erforderlich". Du bekommst 12 Stunden vor jedem Post eine E-Mail mit Vorschau und musst aktiv "Bestätigen" klicken. Wenn du nach ein paar guten Posts Vertrauen in die KI hast, kannst du auf "Nur benachrichtigen" oder "Komplett automatisch" umschalten.',
    modeStrictTitle: 'Bestätigung erforderlich (empfohlen für den Start)',
    modeStrictDesc: 'Du bekommst 12 Stunden vor jedem Post eine E-Mail mit Vorschau. Wir posten NUR, wenn du "Bestätigen" klickst. Ignorierst du die E-Mail, überspringen wir den Slot.',
    modeNotifyTitle: 'Nur benachrichtigen',
    modeNotifyDesc: 'Du bekommst die Vorschau-E-Mail wie gewohnt, aber wir posten automatisch. Außer du klickst aktiv "Abbrechen". Gut für die "ich schaue meistens drauf, vertraue aber dem System"-Phase.',
    modeSilentTitle: 'Komplett automatisch (keine E-Mails)',
    modeSilentDesc: 'Set-and-forget: Wir posten ohne Vorschau-E-Mail. Wähle das nur, wenn du der KI komplett vertraust und keine Benachrichtigungen mehr willst.',
    queue: 'Warteschlange',
    queueCount: '{{count}} Einträge',
    history: 'Verlauf',
    generateNow: 'Jetzt generieren',
    noQueue: 'Keine Einträge in der Warteschlange',
    noQueueDesc: 'Klicken Sie "Jetzt generieren" oder aktivieren Sie Auto Post',
    noHistory: 'Noch keine abgeschlossenen Auto-Posts',
    totalPosts: 'Gesamt Posts',
    successRate: 'Erfolgsrate',
    failed: 'Fehlgeschlagen',
    noSocialsWarning: 'Keine Social-Media-Konten verbunden',
    noSocialsDesc: 'Verbinden Sie Ihre Social-Media-Konten unter "Social Media", bevor Sie Auto Post aktivieren.',
    connectSocials: 'Verbinden',
    enableWithoutSocials: 'Bitte verbinden Sie zuerst Ihre Social-Media-Konten.',
    // v1.6. Hard-gate copy. The toggle is `disabled` (not just toast-
    // refused) until every item below is in place, and the banner above
    // it lists the missing pieces so the user knows exactly what to fix.
    gateBannerTitle: 'Setup unvollständig. Auto-Post deaktiviert',
    gateBannerTitleSoft: 'Setup-Lücke entdeckt',
    gateMissingName: 'Name im Profil fehlt',
    gateMissingBranding: 'Profilfoto oder Logo fehlt',
    gateMissingSocials: 'Keine Plattformen verbunden',
    gateMissingProperties: 'Keine Immobilie importiert',
    gateTooltipPrefix: 'Setup unvollständig:',
    gateBlocked: 'Setup unvollständig',
    gateCta: 'Setup vervollständigen',
    saved: 'Einstellungen gespeichert!',
    saveFailed: 'Speichern fehlgeschlagen',
    loadFailed: 'Einstellungen konnten nicht geladen werden',
    discarded: 'Änderungen verworfen.',
    // Sticky sub-nav labels (one per settings section)
    nav: {
      sources:       'Quellen',
      schedule:      'Plan',
      platforms:     'Plattformen',
      templates:     'Vorlagen',
      captions:      'Captions',
      voiceover:     'Voiceover',
      notifications: 'Benachrichtigungen',
      ai:            'KI',
      captionStyle:  'Caption-Stil',
      music:         'Musik',
    },
    captionsSectionDesc: 'Wie die KI Bildunterschriften und Hashtags erstellt.',
    voiceoverSectionDesc: 'Die KI-Stimme, die den Sprechtext im Video spricht.',
    notificationsSectionDesc: 'Die Vorschau-E-Mail, die du vor jedem geplanten Post bekommst.',
    // Floating "unsaved changes" bar
    unsavedBar: {
      title:      'Du hast ungespeicherte Änderungen',
      titleShort: 'Änderungen ungespeichert',
      discard:    'Verwerfen',
      aria:       'Ungespeicherte Änderungen',
    },
    // Detail modal. Opens when user clicks a queue or history row.
    // Shows the rendered video + per-platform captions; pre-post
    // items get editable + approve/reject + regenerate.
    detail: {
      captionsEditable:    'Captions (bearbeitbar pro Plattform)',
      captionsReadOnly:    'Captions',
      regenerate:          'Neu generieren',
      regenerateHint:      'KI generiert neue Captions',
      regenerating:        'Generiere…',
      regenerated:         'Captions neu generiert.',
      regenerateFailed:    'Neu generieren fehlgeschlagen.',
      regenerateWarn:      'Du hast ungespeicherte Änderungen. Trotzdem neu generieren? (verwirft deine Bearbeitung)',
      chars:               'Zeichen',
      videoRendering:      'Video wird gerade erstellt. Vorschau erscheint hier sobald fertig.',
      saved:               'Captions gespeichert.',
      saveFailed:          'Speichern fehlgeschlagen.',
      approve:             'Freigeben',
      reject:              'Ablehnen',
      stop:                'Stoppen',
      approved:            'Post bestätigt. Wird zur geplanten Zeit veröffentlicht.',
      rejected:            'Post abgebrochen.',
      decisionFailed:      'Aktion fehlgeschlagen.',
      saveBeforeDecision:  'Änderungen vor dem Bestätigen speichern',
      readOnlyCompleted:   'Dieser Post ist bereits veröffentlicht und kann nicht mehr bearbeitet werden.',
      readOnlyRejected:    'Dieser Post wurde abgebrochen.',
      readOnlyOther:       'Dieser Post ist nicht mehr bearbeitbar.',
      errorLabel:          'Fehlermeldung',
    },
    postCreated: 'Post für {{property}} erstellt',
    postCreateFailed: 'Post konnte nicht erstellt werden',
    entryDeleted: 'Eintrag gelöscht',
    deleteFailed: 'Löschen fehlgeschlagen',
    retryStarted: 'Erneuter Versuch gestartet',
    retryFailed: 'Erneuter Versuch fehlgeschlagen',
    refreshFailed: 'Aktualisierung fehlgeschlagen',
    property: 'Immobilie',
    unknown: 'Unbekannt',
    photos: '{{count}} Fotos',
    status: {
      pending: 'Ausstehend',
      claiming: 'Wird übernommen',
      generating_video: 'Video wird erstellt',
      // require_approval mode: silence == skip, label must convey urgency.
      preview_pending: 'Wartet auf deine Freigabe',
      // auto_with_preview mode: silence == post, label must convey
      // that nothing is required of the user. Keyed on `_auto` so the
      // queue row + detail modal can pick the right one off the config.
      preview_pending_auto: 'Vorschau bereit · postet automatisch',
      video_ready: 'Video fertig',
      posting: 'Wird gepostet',
      completed: 'Veröffentlicht',
      completed_partial: 'Teilweise veröffentlicht',
      claiming_post: 'Wird gepostet',
      cancelled: 'Abgesagt',
      rejected: 'Abgebrochen',
      failed: 'Fehlgeschlagen',
    },
  },
  properties: {
    autoPostPaused: 'Auto-Post pausiert',
    title: 'Immobilien',
    subtitle: 'Verwalte deine Inserate',
    addProperty: 'Immobilie hinzufügen',
    addFirst: 'Erste Immobilie anlegen',
    importJustimmo: 'Von Justimmo importieren',
    noProperties: 'Noch keine Immobilien',
    noPropertiesDesc: 'Importiere Immobilien von Justimmo oder lege eine manuell an.',
    createFirst: 'Lege deine erste Immobilie an, um Videos zu erzeugen.',
    loadFailed: 'Immobilien konnten nicht geladen werden.',
    deleteConfirm: 'Möchtest du diese Immobilie wirklich löschen?',
    deleted: 'Immobilie gelöscht',
    rooms: 'Zimmer',
    area: 'Fläche',
    generateVideo: 'Video erstellen',
    viewDetails: 'Details anzeigen',
    // Search + sort + filter (PropertiesPage)
    searchPlaceholder: 'Titel oder Adresse suchen…',
    sortUpdatedDesc: 'Zuletzt aktualisiert',
    sortCreatedDesc: 'Zuletzt erstellt',
    sortTitleAsc: 'Titel A–Z',
    sortPriceDesc: 'Preis absteigend',
    sortPriceAsc: 'Preis aufsteigend',
    filterAll: 'Alle',
    filterWithVideo: 'Mit Video',
    filterInRotation: 'Auto-Post aktiv',
    filterNoActivity: 'Ohne Aktivität',
    autoPostActive: 'Auto-Post aktiv',
    countLine: '{{count}} Immobilien',
    more: '+{{count}} weitere',
    noMatches: 'Keine Treffer für „{{query}}".',
    resetFilters: 'Filter zurücksetzen',
  },
  social: {
    title: 'Social Media',
    subtitle: 'Verwalten Sie Ihre verbundenen Konten',
    connectAccount: 'Konto verbinden',
    connecting: 'Wird verbunden...',
    connectedAccounts: 'Verbundene Konten',
    noAccounts: 'Keine Konten verbunden',
    noAccountsDesc: 'Verbinden Sie Ihre Social-Media-Konten, um Videos zu posten.',
    publish: 'Veröffentlichen',
    publishing: 'Wird veröffentlicht...',
    publishSuccess: 'Erfolgreich veröffentlicht!',
    publishFailed: 'Veröffentlichung fehlgeschlagen',
    selectPlatform: 'Mindestens eine Plattform auswählen',
    publishHistory: 'Veröffentlichungsverlauf',
    connectionFailed: 'Verbindung konnte nicht gestartet werden',
  },
  imageUpload: {
    invalidType: 'Bitte laden Sie ein JPG, PNG, WebP oder GIF Bild hoch',
    tooLarge: 'Bild muss kleiner als 5MB sein',
    uploadFailed: 'Upload fehlgeschlagen',
    uploadSuccess: 'Bild erfolgreich hochgeladen!',
    uploadError: 'Bild konnte nicht hochgeladen werden',
    removed: 'Bild entfernt',
    uploading: 'Hochladen...',
    uploaded: 'Bild hochgeladen',
    clickOrDragReplace: 'Klicken oder ziehen zum Ersetzen',
    dragOrClick: 'Bild hierher ziehen oder klicken',
    maxSize: 'JPG, PNG, WebP oder GIF (max 5MB)',
    orPasteUrl: 'Oder direkt eine Bild-URL einfügen',
  },
  timezones: {
    vienna: 'Wien (CET)',
    berlin: 'Berlin (CET)',
    zurich: 'Zürich (CET)',
    london: 'London (GMT)',
    newYork: 'New York (EST)',
  },
  profile: {
    title: 'Profil',
    subtitle: 'Ihre Daten erscheinen in Video-Outros',
    name: 'Name',
    email: 'E-Mail',
    phone: 'Telefon',
    brandName: 'Firmenname',
    photo: 'Profilfoto',
    logo: 'Firmenlogo',
    saved: 'Profil gespeichert!',
    saveFailed: 'Speichern fehlgeschlagen',
    uploadPhoto: 'Foto hochladen',
    uploadLogo: 'Logo hochladen',
    dragDrop: 'Datei hierher ziehen oder klicken',
    maxSize: 'Max. 5 MB (JPG, PNG, WebP)',
    // DSGVO controls (Art. 17 + 20)
    dataAndAccountTitle: 'Daten & Konto',
    dataAndAccountSubtitle: 'Lade alle deine Daten als ZIP herunter (DSGVO Art. 20) oder lösche dein Konto endgültig (DSGVO Art. 17).',
    exportTitle: 'Meine Daten herunterladen',
    exportHelp: 'ZIP mit allen Datensätzen, die wir zu deinem Account speichern. API-Tokens und Passwörter sind ausgeschlossen.',
    exportButton: 'ZIP herunterladen',
    exportDone: 'Daten exportiert.',
    exportFailed: 'Export fehlgeschlagen.',
    deleteTitle: 'Konto löschen',
    deleteHelp: 'Markiert dein Konto zur Löschung. Du wirst ausgeloggt und 7 Tage später werden alle Daten endgültig entfernt. Schreib uns innerhalb der 7 Tage, um die Löschung rückgängig zu machen.',
    deleteButton: 'Konto löschen',
    deleteConfirmWord: 'LÖSCHEN',
    deletePrompt: 'Tippe {{word}} um die Löschung zu bestätigen. Du hast danach 7 Tage Zeit, die Löschung per E-Mail rückgängig zu machen.',
    deleteScheduled: 'Konto zur Löschung vorgemerkt. Du wirst jetzt ausgeloggt.',
    deleteCancelled: 'Löschung abgebrochen.',
    deleteFailed: 'Löschung fehlgeschlagen.',
  },
  gallery: {
    title: 'Video-Galerie',
    subtitle: 'Alle generierten Immobilienvideos',
    noVideos: 'Noch keine Videos',
    noVideosDesc: 'Videos werden hier angezeigt, sobald sie generiert wurden.',
    downloadVideo: 'Video herunterladen',
    viewProperty: 'Immobilie ansehen',
    createProperty: 'Immobilie erstellen',
    generationFailed: 'Generierung fehlgeschlagen',
    generating: 'Video wird generiert...',
    noFilteredVideos: 'Keine {{filter}} Videos',
    noFilteredDesc: 'Momentan keine {{filter}} Videos vorhanden',
    createFirst: 'Erstellen Sie Immobilien und generieren Sie Videos',
    filter: {
      all: 'Alle',
      ready: 'Fertig',
      processing: 'In Bearbeitung',
    },
    // Date-bucketed sections (added with the gallery rework)
    bucketToday: 'Heute',
    bucketThisWeek: 'Diese Woche',
    bucketOlder: 'Älter',
    goToProperty: 'Zur Immobilie',
  },
  // Modal for manually creating a property (replaces /properties/new)
  newProperty: {
    title: 'Neue Immobilie',
    tabBroker: 'Anbieter-Profil',
    tabWillhaben: 'Einzelnes Inserat',
    tabManual: 'Manuell',
    imagesLabel: 'Bilder',
    uploading: 'Wird hochgeladen…',
    dragOrClick: 'Bilder hierhin ziehen oder klicken',
    imageHint: 'JPG, PNG, WebP, GIF · max 5 MB pro Datei · mehrere möglich',
    coverBadge: 'Cover',
    showUrlPaste: 'Oder Bild-URLs einfügen',
    hideUrlPaste: 'URL-Eingabe ausblenden',
    titleLabel: 'Titel',
    titlePlaceholder: 'Schönes Familienhaus in Wien',
    descriptionLabel: 'Beschreibung',
    descriptionPlaceholder: 'Charmante Immobilie in begehrter Lage…',
    priceLabel: 'Preis',
    locationLabel: 'Adresse',
    highlightsLabel: 'Highlights',
    highlightPlaceholder: 'z.B. 4 Zimmer · 130 m² · Garten',
    addHighlight: 'Highlight hinzufügen',
    create: 'Immobilie erstellen',
    // ICU plural shape. T() picks the matching key based on params.count
    imagesUploaded: {
      one: 'Bild hochgeladen.',
      other: '{{count}} Bilder hochgeladen.',
    },
    fillRequired: 'Bitte alle Pflichtfelder ausfüllen.',
    imagesRequired: 'Mindestens ein Bild ist erforderlich.',
    created: 'Immobilie erstellt.',
    createFailed: 'Immobilie konnte nicht erstellt werden.',
  },
  pricing: {
    title: 'Preise',
    subtitle: 'Wählen Sie Ihren Plan',
    subtitlePro: 'Du bist im Autopilot-Plan. Vielen Dank!',
    subtitleFree: 'Der Autopilot übernimmt das Posten für dich',
    free: 'Kostenlos',
    pro: 'Professional',
    monthly: '/ Monat',
    currentPlan: 'Aktueller Plan',
    selectPlan: 'Plan wählen',
    downgrade: 'Downgrade',
    upgradeNow: 'Jetzt upgraden',
    redirecting: 'Weiterleitung...',
    recommended: 'Empfohlen',
    active: 'Aktiv',
    perfectStart: 'Perfekt zum Starten',
    forProfessionals: 'Wir posten für dich. Täglich, vollautomatisch',
    videosUsed: 'Videos genutzt: {{used}} / {{max}}',
    renews: 'Verlängerung: {{date}}',
    manageSubscription: 'Abrechnung verwalten',
    portalFailed: 'Konnte das Abrechnungsportal nicht öffnen.',
    questions: 'Fragen? Kontaktieren Sie uns unter support@real-content.at',
    // A9. Solo + Team tier copy
    month: 'Monat',
    comingSoon: 'Demnächst',
    forAgencies: 'Für Maklerbüros mit mehreren Mitarbeitern',
    teamBaseHint: '2 Nutzer inklusive · jeder zusätzliche Nutzer +€89 / Monat',
    teamFeature1: 'Alles aus Autopilot, für jeden Mitarbeiter',
    teamFeature2: 'Multi-Account-Verwaltung',
    teamFeature3: 'Pro Makler ein eigenes Justimmo-Profil',
    teamFeature4: 'Zentrale Abrechnung über einen Account',
    teamFeature5: 'Mitglieder jederzeit hinzufügen/entfernen. Anteilig abgerechnet',
    notifyMe: 'Bei Verfügbarkeit benachrichtigen',
    // v1.5. Team CTAs on PricingPage. The button text changes based
    // on the user's current tier so the same card serves first-time
    // signup, upgrade-from-Solo, and "you're already on Team" cases.
    startTeam: 'Team starten',
    upgradeToTeam: 'Auf Team wechseln',
    // v1.8. Starter tier (€29 / 5 Videos / keine Automatisierung)
    forCasual: 'Du erstellst Videos und postest selbst',
    startStarter: 'Starter wählen',
    upgradeToSolo: 'Auf Autopilot upgraden',
    switchInPortal: 'Im Abrechnungsportal wechseln',
    videosUsedMonthly: 'Diesen Monat: {{used}} / {{max}} Videos',
    switchToStarter: 'Zu Starter wechseln',
    downgradeFree: 'Zu Free wechseln',
    freeFrom: 'Free ab {{date}}',
    cancelScheduled: 'Abo endet am {{date}}, danach Free',
    resumeSub: 'Abo fortsetzen',
    planChanged: 'Tarif gewechselt.',
    planChangeFailed: 'Tarifwechsel fehlgeschlagen.',
    confirmUpgrade: 'Auf Autopilot wechseln? Die Differenz für den laufenden Monat wird anteilig verrechnet.',
    confirmDowngrade: 'Zu Starter wechseln? Auto-Posting, Social-Konten und Auto-Import werden deaktiviert. Die Preisdifferenz wird dir gutgeschrieben.',
    confirmCancel: 'Zu Free wechseln? Dein Abo läuft bis zum Ende des bezahlten Zeitraums{{date}} normal weiter und endet dann. Du kannst das bis dahin jederzeit rückgängig machen.',
    cancelScheduledToast: 'Kündigung vorgemerkt. Bis zum Periodenende bleibt alles aktiv.',
    cancelFailed: 'Kündigung fehlgeschlagen.',
    resumed: 'Abo läuft weiter. Schön, dass du bleibst!',
    resumeFailed: 'Konnte das Abo nicht fortsetzen.',
    features: {
      freeVideos: '5 Videos / Monat',
      freeQuality: '720p Videoqualität',
      freeTemplates: 'Basis-Templates',
      freeSupport: 'E-Mail-Support',
      starterVideos: '5 Videos / Monat, auf Abruf erstellt',
      starterNoAutopost: 'Kein Auto-Posting: das übernimmt der Autopilot-Tarif',
      starterImports: 'Inserate-Import aus Justimmo & Willhaben',
      voiceMusic: 'KI-Voiceover & Musik in jedem Video',
      // The two top features sell the *outcome*. What the user actually
      // wants. Volume / quality / templates are table-stakes underneath.
      autoPost: 'Postet täglich automatisch: Instagram, TikTok, Facebook, YouTube, LinkedIn & X',
      zeroEffort: 'Null Aufwand: 12h-Vorschau per Mail, du gibst nur frei',
      autoImport: 'Neue Inserate werden automatisch importiert',
      unlimitedVideos: 'Über 30 Videos pro Monat',
      hdQuality: 'Full HD 1080p Qualität',
      allTemplates: 'Alle Premium-Templates',
      branding: 'Eigenes Branding (Logo, Foto, Marke)',
      socialMedia: 'Social-Media-Integration',
      prioritySupport: 'Prioritäts-Support',
      support: 'Prioritätssupport',
    },
  },
  landing: {
    // Hero. Rendered clause-per-line (split on '.'), last clause gets
    // the violet→teal gradient. 2026-09 rebrand: the slogan is the
    // speed promise — "Vom Inserat zum professionellen Immobilienvideo.
    // In 30 Sekunden." Input (your existing listing) → output
    // (professional video), with the wow-factor timing as the
    // gradient punchline.
    hero: 'Vom Inserat zum professionellen Immobilienvideo. In 30 Sekunden.',
    // Subtitle backs the slogan up with the mechanism: paste a link,
    // get a finished branded video, optionally full auto-posting on
    // top. Still names Justimmo/Willhaben to pre-qualify the audience.
    heroSubtitle: 'Willhaben-Link einfügen, fertiges Video mit KI-Voiceover, Musik und deinem Branding erhalten. Und wenn du willst, posten wir täglich automatisch auf Instagram, TikTok, Facebook, YouTube, LinkedIn und X.',
    startFree: 'Kostenlos starten',
    watchDemo: 'Demo ansehen',
    // Numbered section kickers (drafting-sheet labels, v1.8 redesign)
    heroFrameCaption: 'Direkt aus dem Inserat gerendert. In 30 Sekunden.',
    kickerExamples: 'Beispiele',
    kickerWhy: 'Warum wir',
    kickerCompare: 'Der Vergleich',
    kickerHow: 'Ablauf',
    kickerPricing: 'Preise',
    kickerStart: 'Start',
    features: 'Funktionen',
    howItWorks: 'So funktioniert\'s',
    testimonials: 'Das sagen unsere Kunden',
    // Audience-targeted, not technology-targeted. The badge above the
    // hero used to say "KI-Marketing für Immobilienmakler". Generic.
    // Now it speaks directly to the pain: visibility online.
    aiPowered: 'Für Makler, die täglich posten müssten. Aber keine Zeit haben',
    // Feature copy. Benefit-led, not function-led. Each title is a
    // mini-promise (what changes for you) and the description quietly
    // names the mechanism. Old copy described the product ("KI-Captions
    // & Hashtags"); new copy describes the outcome ("Captions in deinem
    // Stil. Nicht nach Marketing-Bot.")
    feature1Title: 'Aus deinem CRM. Ohne Copy-Paste.',
    feature1Desc: 'Justimmo oder Willhaben einmal verbinden. Inserate, Bilder und Texte ziehen wir automatisch. Du tippst nichts ab.',
    feature2Title: 'Captions in deinem Stil.',
    feature2Desc: 'Die KI lernt deinen Schreibstil aus bisherigen Posts. Captions klingen nach dir. Nicht nach Marketing-Bot.',
    feature3Title: 'Videos wie aus der Agentur.',
    feature3Desc: 'Story-, Reel- und Feed-Templates mit deinem Logo, deinen Farben und einer KI-Stimme in sechs deutschen Varianten.',
    feature4Title: 'Sechs Plattformen. Ein Klick.',
    feature4Desc: 'Instagram, TikTok, Facebook, YouTube, X und LinkedIn. Gepostet aus einem Dashboard. 12-Stunden-Vorschau per Mail vor jedem Post.',
    seeCreations: 'So sehen deine Videos aus',
    realExamples: 'Neun Immobilien, neun Vorlagen. Jedes Video wurde komplett automatisch aus den Inseratsfotos erstellt.',
    galleryTemplate: 'Vorlage {{name}}',
    everythingYouNeed: 'Warum Makler bei uns bleiben',
    forProfessionals: 'Vier Dinge, die kein DIY-Tool und keine Agentur in dieser Kombination liefert',
    howItWorksTitle: 'In 5 Minuten eingerichtet. Danach läuft es.',
    threeSteps: 'Drei Schritte. Und du musst nie wieder einen Post „schnell zwischendurch" machen',
    step1Title: 'Quelle verbinden',
    step1Desc: 'Justimmo, Willhaben oder dein CRM mit zwei Klicks koppeln. Deine Inserate landen automatisch im Konto.',
    step2Title: 'Stil festlegen',
    step2Desc: 'Logo hochladen, Markenfarben wählen, ein paar deiner alten Posts importieren. Die KI lernt deinen Schreibstil.',
    step3Title: 'Laufen lassen',
    step3Desc: 'Wir rendern täglich ein Video, mailen dir 12 Stunden vorher eine Vorschau. Du klickst „Freigeben". Gepostet.',
    // ── Alternatives comparison (DIY / Agentur / Real Content) ───
    // Sandwiched between Features and How-It-Works to anchor the
    // decision: the visitor already knows what we do, now they need
    // to see why we beat their two existing options. Honest about
    // each path's trade-offs. Credibility is more persuasive than
    // hyperbole.
    compareTitle: 'DIY, Agentur oder Real Content?',
    compareSubtitle: 'Du hast drei Wege, sichtbar zu werden. Hier ist der ehrliche Vergleich.',
    compareDiyTitle: 'Selber machen',
    compareDiyPrice: '€0 / Monat',
    compareDiyTime: '4–6 Stunden pro Woche',
    compareDiyCon1: 'Du verbringst Abende mit Schnitt statt mit Kunden',
    compareDiyCon2: 'Posts wirken oft schnell zusammengeschustert',
    compareDiyCon3: 'Reichweite bleibt klein, weil du nicht täglich postest',
    compareAgencyTitle: 'Social-Media-Agentur',
    compareAgencyPrice: '€500–2.000 / Monat',
    compareAgencyTime: '2–3 Abstimmungstermine im Monat',
    compareAgencyCon1: 'Du schreibst trotzdem Briefings und gibst Korrekturen',
    compareAgencyCon2: 'Die Agentur kennt deine Inserate nicht. Der Workflow bleibt zäh',
    compareAgencyCon3: 'Bei Vertragsende fällt die ganze Routine in sich zusammen',
    compareRcTitle: 'Real Content',
    compareRcBadge: 'Unsere Empfehlung',
    compareRcPrice: 'ab €29 / Monat',
    compareRcTime: '5 Minuten Setup. Dann vollautomatisch.',
    compareRcPro1: 'Liest direkt aus Justimmo / Willhaben. Du tippst kein Wort ab',
    compareRcPro2: 'Tägliches Video, automatisch auf sechs Plattformen',
    compareRcPro3: '12-Stunden-Vorschau per Mail. Du behältst die Kontrolle',
    pricing: 'Preise',
    simplePricing: 'Faire Preise. Kein Kleingedrucktes.',
    startFreeUpgrade: 'Kostenlos starten, jederzeit upgraden. Wenn überhaupt',
    perfectStart: 'Zum Ausprobieren',
    forSerious: 'Posten läuft von allein',
    mostPopular: 'Beliebteste Wahl',
    getStartedFree: 'Kostenlos starten',
    startPro: 'Pro starten',
    readyToTransform: 'Bereit, deine Inserate selbst zu posten. Ohne sie selbst zu posten?',
    joinProfessionals: 'Starte kostenlos. Keine Kreditkarte. In 5 Minuten läuft dein erstes Video.',
    noCreditCard: 'Keine Kreditkarte für Free nötig',
    // Risk-reversal pills. Shown immediately under the hero CTA so a
    // skeptical agent has "no card / free tier / cancel anytime" above the
    // fold instead of buried in the footer.
    trustNoCard: 'Keine Kreditkarte für Free nötig',
    trustFreeForever: '5 Videos gratis, jeden Monat',
    trustCancel: 'Jederzeit kündbar',
    tapToUnmute: 'Tippe auf ein Video, um den AI-Voiceover zu hören',
    signIn: 'Anmelden',
    getStarted: 'Loslegen',
    privacy: 'Datenschutz',
    terms: 'AGB',
    contact: 'Kontakt',
    // ── v1.5. Pricing section on the landing page ──────────────
    pricingSubtitle: 'Monatliche Abrechnung. Jederzeit kündbar. Keine Mindestlaufzeit.',
    // Trust strip badges (4 in a row above the pricing cards)
    trustMonthly: 'Monatlich abrechnen',
    trustMonthlyDetail: 'Keine Jahresverträge.',
    trustCancelAnytime: 'Jederzeit kündbar',
    trustCancelAnytimeDetail: 'Ein Klick im Kundenportal.',
    trustDsgvo: 'DSGVO-konform',
    trustDsgvoDetail: 'Server in der EU. Daten-Export jederzeit.',
    trustStripe: 'Sichere Zahlung',
    trustStripeDetail: 'Abgewickelt über Stripe (PCI-DSS Level 1).',
    // Starter card (CTA + features) — v1.8 casual tier
    startStarter: 'Starter wählen',
    forOccasional: 'Videos erstellen, selbst posten',
    starterFeature1: '5 Videos pro Monat',
    starterFeature2: 'Alle Templates inklusive Premium',
    starterFeature3: 'Inserate-Import aus Justimmo & Willhaben',
    starterFeature4: 'KI-Voiceover, Musik & dein Branding',
    starterFeature5: 'Full HD 1080p',
    // Solo card (CTA + features)
    startSolo: 'Autopilot starten',
    soloFeature1: 'Täglich 1 Video, automatisch erstellt und gepostet',
    soloFeature2: 'Auto-Import neuer Inserate aus Justimmo & Willhaben',
    soloFeature3: 'Postet von allein auf 6 Plattformen',
    soloFeature4: '12-Stunden-Vorschau: du gibst nur frei',
    soloFeature5: 'Priority-Support',
    // Team card (CTA + features + savings hint)
    startTeam: 'Team starten',
    teamBadge: 'Agentur',
    forAgencies: 'Der Autopilot fürs ganze Büro',
    teamPriceHint: '2 Plätze inklusive · jeder weitere +€89',
    teamFeature1: 'Alles aus Autopilot, für jeden Mitarbeiter',
    teamFeature2: 'Pro Makler ein eigener Inserate-Import',
    teamFeature3: 'Mitglieder jederzeit hinzufügen. Anteilig abgerechnet',
    teamFeature4: 'Eine Rechnung für die ganze Agentur',
    teamSavingsTitle: 'Beispiel: 4 Makler',
    teamSavingsBody: '4× Autopilot = €396 / Monat · Team = €357 / Monat. Du sparst €39 / Monat (€468 / Jahr).',
    // Inline FAQ under the cards
    pricingFaqTitle: 'Häufige Fragen vor dem Start',
    pricingFaq1Q: 'Kann ich jederzeit kündigen?',
    pricingFaq1A: 'Ja. Ein Klick im Stripe-Abrechnungsportal. Du behältst Zugriff bis zum Ende des bezahlten Zeitraums, danach wechselst du automatisch auf Free.',
    pricingFaq2Q: 'Was passiert mit meinen Videos, wenn ich kündige?',
    pricingFaq2A: 'Alle bisher erstellten Videos bleiben in deinem Konto und du kannst sie jederzeit herunterladen. Nach der Kündigung werden lediglich keine neuen Videos mehr automatisch erstellt.',
    pricingFaq3Q: 'Brauche ich eine Kreditkarte für Free?',
    pricingFaq3A: 'Nein. Free-Renders erfordern nur eine bestätigte E-Mail-Adresse. Keine Karte, keine Stripe-Daten. Erst wenn du auf Solo upgradest, kommt eine echte Zahlungsmethode ins Spiel.',
    pricingFaq4Q: 'Kann ich von Autopilot auf Team wechseln?',
    pricingFaq4A: 'Ja. Kündige Autopilot im Portal, starte das Team-Abo neu. Deine Immobilien & Videos bleiben erhalten.',
    pricingFaqMorePrefix: 'Mehr Fragen?',
    pricingFaqMoreLink: 'Komplette FAQ ansehen',
    // ── v1.7. Viral-demo paste-bar (hero) ────────────────────────
    demoPlaceholder: 'Willhaben-URL einfügen…',
    demoCta: 'Reel erstellen',
    demoLoading: 'Wir rendern…',
    demoHint: 'Kostenlos · Kein Account nötig · In ~60 Sekunden fertig',
    demoOr: 'oder',
    demoErrorGeneric: 'Etwas ist schiefgelaufen. Bitte erneut versuchen.',
    // Fallback only. The backend ships the funnel-tuned German
    // 429 detail directly on the response. This kicks in only if the
    // response detail is missing (network blip, etc.).
    demoErrorRateLimit: 'Du hast dein Demo-Limit erreicht. Erstelle ein kostenloses Konto, um sofort weitere Videos zu generieren. Ohne Demo-Wasserzeichen.',
    demoQuotaSignupCta: 'Kostenloses Konto erstellen',
  },
  // v1.7. Viral demo share page (/demo/:token).
  demo: {
    loading: 'Lade Demo…',
    errorTitle: 'Hier stimmt was nicht',
    errorLoad: 'Diese Demo konnte nicht geladen werden.',
    backToLanding: 'Zur Startseite',
    previewBadge: 'Dein Demo-Reel',
    fallbackTitle: 'Deine Immobilie als Reel',
    renderingTitle: 'Wir rendern dein Reel…',
    renderingHint: 'Voiceover, Animationen, Branding. Ca. 60 Sekunden.',
    renderingButton: 'Render läuft…',
    queuedHint: 'Anzeige eingelesen. Render läuft. Sobald das Video fertig ist, kannst du es kostenlos in dein Konto speichern.',
    failedTitle: 'Render fehlgeschlagen',
    failedBody: 'Versuch es nochmal mit einer anderen Anzeige.',
    failedRetryHint: 'Manchmal antwortet Willhaben langsam. Probier es mit einer anderen Anzeige.',
    tryAnother: 'Andere Immobilie probieren',
    tapHint: 'Tippe das Video an, um den Voiceover zu hören',
    saveTitle: 'Reel in deinen Account speichern',
    saveBody: 'Erstelle in 30 Sekunden ein kostenloses Konto. Und das Video wird in deinem Dashboard sichtbar.',
    signupCta: 'Kostenloses Konto erstellen',
    claimNow: 'Jetzt in mein Konto speichern',
    signupHint: 'Keine Kreditkarte · 5 Renders gratis pro Monat',
    unlockTemplates: 'Andere Vorlagen probieren',
    unlockTemplatesBody: '11 Templates. Story, Reel, Feed-Post.',
    unlockAutoPost: 'Auto-Post auf 6 Plattformen',
    unlockAutoPostBody: 'Instagram, TikTok, Facebook, YouTube, LinkedIn, X.',
    footerPitch: 'Dieses Video wurde automatisch aus einem Willhaben-Inserat erstellt. Von Real Content. Verbinde Justimmo oder Willhaben und wir machen täglich eines für dich.',
    footerLearnMore: 'Mehr erfahren',
    claimSuccess: 'Dein Demo-Video wurde deinem Konto hinzugefügt.',
  },
  // v1.5. Team subscription management UI (TeamPage + invite flow).
  team: {
    // Start-a-team card (no team yet)
    startTitle: 'Starte ein Team',
    startSubtitle: 'Mehrere Makler unter einer Abrechnung. Günstiger als einzelne Solo-Abos.',
    startCardTitle: 'Team-Abo einrichten',
    startCardSubtitle: 'Wähle die Anfangs-Anzahl der Plätze. Du kannst jederzeit Mitglieder hinzufügen oder entfernen. Wir rechnen das anteilig auf der nächsten Rechnung ab.',
    nameLabel: 'Team-Name',
    namePlaceholder: 'Mustermann Immobilien',
    seatsLabel: 'Plätze (mind. 2)',
    fewerSeats: 'Weniger Plätze',
    moreSeats: 'Mehr Plätze',
    priceLabel: 'Monatlich',
    priceBase: 'für die ersten 2 Plätze',
    priceVsSolo: 'vs. {{solo}}× Solo (€{{solo}}). Sparst €{{save}}',
    startCta: 'Team-Abo starten',
    checkoutHint: 'Stripe-Checkout. Sicher abgewickelt, jederzeit kündbar.',
    checkoutFailed: 'Checkout konnte nicht gestartet werden.',
    // Existing-team header
    defaultName: 'Mein Team',
    subtitle: '{{count}} Plätze · monatliche Abrechnung',
    youAreOwner: 'Du bist Inhaber',
    leaveCta: 'Team verlassen',
    confirmLeave: 'Team wirklich verlassen? Du kannst danach nicht mehr auf Team-Funktionen zugreifen.',
    leftTeam: 'Du hast das Team verlassen.',
    // Members list
    membersTitle: 'Mitglieder',
    membersSubtitle: '{{count}} von {{max}} Plätzen belegt',
    ownerLabel: 'Inhaber',
    noMembers: 'Noch keine Mitglieder.',
    confirmRemove: '{{who}} wirklich aus dem Team entfernen?',
    memberRemoved: 'Mitglied entfernt.',
    removeFailed: 'Entfernen fehlgeschlagen.',
    // Invite form (owner-only)
    inviteTitle: 'Mitglied einladen',
    inviteSubtitle: 'E-Mail-Adresse eingeben. Wir schicken eine Einladung. Beim Annehmen wird automatisch ein Platz hinzugefügt (anteilig abgerechnet).',
    invitePlaceholder: 'kollege@firma.at',
    inviteCta: 'Einladen',
    inviteSent: 'Einladung verschickt.',
    inviteSentNoEmail: 'Einladung erstellt, E-Mail-Versand fehlgeschlagen.',
    inviteFailed: 'Einladung fehlgeschlagen.',
    pendingTitle: 'Offene Einladungen',
    expiresAt: 'läuft ab: {{date}}',
    cancelInvite: 'Widerrufen',
    // Footer billing pointer
    billingHint: 'Abrechnung, Zahlungsmethode und Kündigung über das Stripe-Abrechnungsportal. Siehe Pricing-Seite.',
    toPricing: 'Zur Abrechnung',
    loadFailed: 'Team konnte nicht geladen werden.',
  },
  // v1.5. First-render onboarding (replaces the old 7-step wizard).
  firstRender: {
    // Hero / page chrome
    heroBadge: '60-Sekunden-Test',
    heroTitle: 'Mach jetzt dein erstes Video.',
    heroSubtitle: 'Wähle eine Vorlage. Wir rendern es mit unserer Beispiel-Immobilie. Du musst nichts hochladen, nichts einstellen.',
    skip: 'Später machen',
    demoBadge: 'Beispiel',
    pickTemplate: 'Wähle eine Vorlage',
    clickHint: 'Klick. Wir rendern sofort.',
    useTemplate: 'Diese rendern',
    templateCount: '{{count}} Vorlagen verfügbar',
    noTemplatesForProperty: 'Keine Vorlage passt zu deiner Bildanzahl. Lade ein paar mehr Fotos hoch, dann öffnen sich die Vorlagen.',
    orUploadOwnPrefix: 'Lieber gleich eine eigene Immobilie testen?',
    orUploadOwnLink: 'Eigene Immobilie anlegen',

    // Render-in-progress overlay
    renderingTitle: 'Wir zaubern dein Video…',
    hype1: 'KI sucht die schönsten Aufnahmen aus…',
    hype2: 'Voiceover wird mit deutscher Stimme erstellt…',
    hype3: 'Animationen + Branding werden zusammengesetzt…',
    hype4: 'Letzte Politur. Fast fertig…',

    // Done state. Celebration + upgrade ladder
    doneTitle: 'Magic, oder?',
    doneSubtitle: 'Das ist dein erstes Real-Content-Video. Komplett automatisch erstellt.',
    // Demo-render variant of the done-state copy. The backend sets
    // is_first_render=true on the very first render of a free-tier
    // account; the result page swaps in these strings + a profile-
    // completion banner so the user understands the demo realtor-photo
    // they just saw is the *signal* to fill in their own.
    demoTitle: 'Das war dein Demo.',
    demoSubtitle: 'Mach es zu deinem. Füge dein Foto und Branding hinzu, damit deine nächsten 5 Videos dich zeigen, nicht unser Demo-Modell.',
    demoBadge: 'Demo',
    demoQuotaHint: 'Demo zählt nicht. Du hast noch alle 5 Free-Renders übrig.',
    profileNudgeTitle: 'Dein Foto und Branding fehlen noch',
    profileNudgeBody: 'Im Demo siehst du unser Standard-Maklerfoto. Lade dein Profilbild, Logo und Telefonnummer hoch. Dann zeigt jedes deiner 5 Free-Videos dich.',
    profileNudgeCta: 'Profil vervollständigen',
    nextTitle: 'Was möchtest du als nächstes?',
    nextSubtitle: 'So sieht es mit deinen echten Inseraten aus.',
    ladderJustimmoTitle: 'Justimmo verbinden',
    ladderJustimmoBody: 'Importiere deine echten Inserate automatisch. Täglich ein neues Video, gepostet ohne Mehraufwand.',
    ladderJustimmoCta: 'Mehr erfahren',
    ladderAutoPostTitle: 'Auto-Post aktivieren',
    ladderAutoPostBody: 'KI postet täglich für dich auf Instagram, TikTok & Co. Mit Vorschau-Mail.',
    ladderAutoPostCta: 'Solo ansehen',
    ladderTeamTitle: 'Team starten',
    ladderTeamBody: 'Mehrere Makler unter einer Abrechnung. Ab €179 / Monat.',
    ladderTeamCta: 'Team-Plan',
    toDashboard: 'Zum Dashboard',
    freeQuotaHint: 'Du hast noch 4 weitere Free-Renders übrig. Probiere weitere Vorlagen aus!',

    // Error / fallback states
    bootstrapFailed: 'Konnte Demo nicht laden. Bitte Seite neu laden.',
    renderFailed: 'Render konnte nicht gestartet werden.',
    renderTimeout: 'Render dauert länger als erwartet. Bitte Seite neu laden.',
    statusCheckFailed: 'Status konnte nicht geprüft werden.',
    reload: 'Neu laden',

    // Mode toggle (Beispiel vs Eigene Bilder)
    modeDemo: 'Beispiel verwenden',
    modeManual: 'Eigene Bilder',
    yourProperty: 'Deine Immobilie',
    fillFormFirst: 'Speichere zuerst deine Immobilie oben.',
    noPropertyYet: 'Bitte zuerst eine Immobilie auswählen oder anlegen.',

    // Manual-property form
    imagesLabel: 'Bilder',
    uploading: 'Wird hochgeladen…',
    dragOrClick: 'Bilder hierhin ziehen oder klicken',
    imageHint: 'JPG, PNG, WebP · max 5 MB pro Datei · 3-7 Bilder ideal für die Vorlagen',
    imagesNeed3: 'Mind. 3 Bilder',
    imagesOk: '{{count}} hochgeladen ✓',
    imagesNeedMore: 'noch {{count}} Bild(er) nötig',
    imagesMinThree: 'Bitte mind. 3 Bilder hochladen. Die meisten Vorlagen brauchen Auswahl.',
    titleLabel: 'Titel',
    titleNeed8: 'Mind. 8 Zeichen',
    titleShort: 'noch {{remaining}}',
    titleTooShort: 'Titel ist zu kurz. Mind. 8 Zeichen, damit er im Video gut aussieht.',
    titleHelp: 'Erscheint als Headline + wird vom KI-Voiceover gesprochen.',
    titlePlaceholder: 'Schönes Familienhaus in Wien',
    priceLabel: 'Preis',
    locationLabel: 'Adresse',
    highlightsLabel: 'Highlights (mit Komma trennen)',
    highlightsPlaceholder: '4 Zimmer, 130 m², Garten, Garage',
    descriptionLabel: 'Beschreibung',
    descriptionPlaceholder: 'Charmante Immobilie in begehrter Lage… (oder klick „KI-Beschreibung erstellen")',
    saveProperty: 'Speichern und Vorlage wählen',
    fillRequired: 'Titel, Preis und Adresse sind Pflicht.',
    imagesRequired: 'Mindestens ein Bild ist erforderlich.',
    propertyCreated: 'Immobilie gespeichert. Wähle jetzt eine Vorlage.',
    propertyFailed: 'Speichern fehlgeschlagen.',
    // Form guidance block at the top of the manual form.
    formGuidanceTitle: 'So nutzt das Video deine Eingaben',
    formGuidanceImages: 'Bilder',
    formGuidanceTitle2: 'Titel',
    formGuidancePrice: 'Preis + Adresse',
    formGuidanceHighlights: 'Highlights',

    // AI description button
    aiSuggest: 'KI-Beschreibung erstellen',
    aiDone: 'KI-Vorschlag eingefügt',
    aiHint: 'KI-Vorschlag ist optional. Du kannst danach noch alles anpassen. Eine Generierung pro Sitzung.',
    aiNeedsTitle: 'Bitte zuerst einen Titel eingeben. Die KI braucht einen Anhaltspunkt.',
    aiDescriptionDone: 'Beschreibung erstellt. Du kannst sie noch anpassen.',
    aiFailed: 'KI nicht erreichbar.',

    // Willhaben-import mode
    modeWillhaben: 'Von Willhaben',
    fromWillhabenBadge: 'Aus Willhaben',
    willhabenTitle: 'Inserat von Willhaben importieren',
    willhabenSubtitle: 'Füge den Link zu deinem Willhaben-Inserat ein. Wir holen Titel, Preis, Adresse und alle Fotos automatisch. Kein Tippen, kein Hochladen.',
    willhabenUrlLabel: 'Willhaben-URL',
    willhabenLoadBtn: 'Inserat laden',
    willhabenHint: 'Es muss ein Willhaben-Immobilieninserat sein. Z. B. eine /iad/immobilien/d/… Seite. Wir prüfen vor dem Import noch einmal mit dir.',
    willhabenNeedUrl: 'Bitte eine Willhaben-URL einfügen.',
    willhabenFailed: 'Willhaben-Inserat konnte nicht geladen werden.',
    willhabenChangeUrl: 'Anderes Inserat',
    willhabenSelectImages: 'Bilder fürs Video auswählen',
    willhabenSelectedCount: '{{selected}} von {{total}} ausgewählt',
    willhabenSelectHint: 'Tipp: Das erste ausgewählte Bild wird oft als Cover verwendet. Wähle ein starkes Außenfoto zuerst.',
    willhabenAgreeText: 'Ich bestätige, dass das mein Inserat ist (oder ich vom Eigentümer beauftragt bin) und dass ich die Bilder im Video verwenden darf.',
    willhabenAgreeFirst: 'Bitte bestätige, dass das deine Anzeige ist.',
    willhabenPickThree: 'Bitte mindestens 3 Bilder für das Video auswählen.',
    willhabenImportBtn: 'Importieren und Vorlage wählen',
    willhabenImporting: 'Wird importiert…',
    willhabenImported: 'Anzeige importiert. Wähle jetzt eine Vorlage.',
    willhabenImportFailed: 'Import fehlgeschlagen. Bitte erneut versuchen.',
    willhabenImportFirst: 'Importiere zuerst dein Willhaben-Inserat oben.',
    willhabenOpenOriginal: 'Original öffnen',
    willhabenImportedTitle: 'Inserat importiert!',
    willhabenAskMore: 'Möchtest du auch weitere Inserate vom selben Anbieter importieren?',
    willhabenImportMore: 'Mehr vom Anbieter importieren',
    willhabenDone: 'Fertig',
    editProperty: 'Bearbeiten',
  },
  broker: {
    title: 'Alle Inserate vom Anbieter importieren',
    subtitle: 'Füge den Link zur Willhaben-Anbieter-Seite ein. Z. B. die "Mehr von diesem Anbieter" Seite. Wir holen alle aktiven Inserate, du wählst aus welche du importierst.',
    urlLabel: 'Anbieter-URL',
    loadBtn: 'Anbieter laden',
    hint: 'Tipp: Klick in einem deiner eigenen Willhaben-Inserate auf "Mehr von diesem Anbieter". Die geöffnete Seite ist die richtige URL.',
    needUrl: 'Bitte eine Willhaben-Anbieter-URL einfügen.',
    previewFailed: 'Anbieter-Daten konnten nicht geladen werden.',
    activeCount: '{{count}} aktive Inserate gefunden',
    changeBroker: 'Anderer Anbieter',
    allCategories: 'Alle Kategorien',
    searchPlaceholder: 'Titel/Ort suchen...',
    groupByAgent: 'Nach Makler gruppieren',
    enrichFailed: 'Makler-Namen konnten nicht ermittelt werden.',
    allAgents: 'Alle Makler',
    unknownAgent: '(Ohne Namen)',
    selectedCount: '{{count}} ausgewählt',
    selectAllVisible: 'Alle (sichtbar) auswählen',
    deselectAll: 'Alle abwählen',
    clearAll: 'Auswahl leeren',
    hiddenSelectedHint: '{{count}} weitere ausgewählte Inserate sind durch den Filter ausgeblendet. Sie zählen mit beim Import.',
    clearFilters: 'Filter zurücksetzen',
    alreadyImported: 'Bereits importiert',
    noMatch: 'Keine Inserate passen zu den aktuellen Filtern.',
    pickAtLeastOne: 'Bitte mindestens ein Inserat auswählen.',
    startImport: '{{count}} Inserate importieren',
    startFailed: 'Import konnte nicht gestartet werden.',
    disclaimer: 'Hinweis: Mit dem Import bestätigst du, dass du die Anzeigen erstellt hast oder vom Eigentümer beauftragt bist und die Bilder im Video verwenden darfst.',
    running: 'Inserate werden importiert...',
    done: 'Import abgeschlossen',
    cancelled: 'Import abgebrochen',
    cancelling: 'Wird abgebrochen...',
    cancel: 'Abbrechen',
    errored: 'Fehler',
    doneHint: '{{count}} Inserate sind jetzt in deiner Liste. Du kannst sofort Videos rendern.',
    cancelledHint: 'Bereits importierte Inserate bleiben gespeichert.',
  },
  quickstart: {
    title: 'Deine ersten Schritte',
    subtitle: 'In 4 Schritten zum vollautomatischen Posting. Du kannst jederzeit unterbrechen.',
    completed: 'erledigt',
    allDoneTitle: 'Du bist startklar!',
    allDoneSubtitle: 'Alle Setup-Schritte erledigt. Lehn dich zurück. Der Rest läuft automatisch.',
    finishBtn: 'Großartig. Los geht\'s',
    subtitleFree: 'Dein erstes Video und dein Branding: so holst du das Meiste aus Real Content heraus.',
  },
  subSuccess: {
    startSetup: 'Setup starten',
    welcomeBodyWizard: 'Dein Abo ist aktiv. Lass uns die nächsten 7 Schritte durchgehen: Profil, Datenquelle, Templates, Voiceover, Social Media und Auto-Post. Danach läuft alles automatisch.',
    invalidSession: 'Ungültige Sitzung.',
    timeoutToast: 'Zahlungsbestätigung dauert ungewöhnlich lange. Bitte E-Mail prüfen.',
    toast: 'Zahlung erfolgreich. Willkommen!',
    expired: 'Zahlungs-Sitzung ist abgelaufen.',
    verifyingTitle: 'Zahlung wird bestätigt…',
    verifyingBody: 'Einen Moment, wir aktivieren dein Abo.',
    welcomeTitle: 'Willkommen!',
    welcomeBody: 'Dein Abo ist aktiv. Damit dein Auto-Post auch was zu posten hat, verbinde jetzt deine Datenquelle (Justimmo oder Willhaben). Wir importieren neue Inserate dann täglich automatisch.',
    connectSource: 'Datenquelle verbinden',
    skipToDashboard: 'Später, zum Dashboard',
    errorTitle: 'Zahlung konnte nicht bestätigt werden',
    errorBody: 'Wenn dir Geld abgebucht wurde, melde dich bitte unter support@real-content.at. Wir kümmern uns sofort.',
    tryAgain: 'Erneut versuchen',
    goDashboard: 'Zum Dashboard',
  },
  imports: {
    blockedTitle: 'Gelöschte Inserate',
    blockedDesc: 'Diese Inserate hast du gelöscht. Sie werden nicht mehr automatisch importiert. Mit „Wieder importieren" gibst du sie wieder frei.',
    reimport: 'Wieder importieren',
    title: 'Datenquellen',
    loadFailedTitle: 'Status konnte nicht geladen werden',
    loadFailedBody: 'Wir konnten den Verbindungsstatus deiner Datenquellen nicht abrufen. Bitte erneut versuchen. Die Daten unten könnten unvollständig sein.',
    retry: 'Erneut',
    subtitle: 'Verbinde, von wo deine Immobilien kommen sollen. Listings werden automatisch importiert und stehen sofort für Videos und Auto-Post zur Verfügung.',
    connected: 'Verbunden',
    manage: 'Verwalten',
    connectJustimmo: 'Justimmo verbinden',
    justimmoDesc: 'CRM-Sync. Alle deine Justimmo-Listings stehen automatisch zur Verfügung.',
    willhabenDesc: 'Verlinke dein Anbieter-Profil. Wir scannen täglich nach neuen Inseraten unter deinem Namen und importieren sie automatisch.',
    willhabenAlsoBulk: 'Tipp: Über „Neue Immobilie" → „Anbieter-Profil" kannst du auch jederzeit alle Inserate eines Willhaben-Anbieters auf einmal importieren. Auch ohne aktives Abo dieser Quelle.',
    dupWarningTitle: 'Achtung: Beide Quellen sind aktiv',
    dupWarningBody: 'Wenn dieselbe Immobilie auf Justimmo und Willhaben gelistet ist, importieren wir sie zweimal. Empfehlung: nutze nur eine Quelle als deinen primären Kanal. Meistens dein CRM (Justimmo). Und deaktiviere die andere.',
    account: 'Konto',
    scopedTo: 'Inserate von',
    imported: 'Importiert',
    properties: 'Immobilien',
    helpHeader: 'Wie hängt das alles zusammen?',
    helpRow1: 'Importierte Listings landen in deinen "Immobilien" und sind sofort für Videos verfügbar.',
    helpRow2: 'Hast du Auto-Post aktiviert, werden neue Listings auch dort automatisch berücksichtigt.',
    helpRow3: 'Du kannst jederzeit eine Quelle trennen. Bereits importierte Immobilien bleiben erhalten.',
    toProperties: 'Zu meinen Immobilien',
  },
  subscription: {
    sectionTitle: 'Willhaben Anbieter-Profil',
    sectionDesc: 'Verknüpfe dein Willhaben-Anbieter-Profil, damit neue Inserate täglich automatisch importiert werden.',
    connectTitle: 'Anbieter-Profil verknüpfen',
    connectSub: 'Wir scannen täglich nach neuen Inseraten unter deinem Namen und importieren sie automatisch.',
    idleHint: 'Verlinke dein Willhaben-Anbieter-Profil. Wir scannen täglich nach neuen Inseraten und importieren sie automatisch, sodass sie für deinen Auto-Post zur Verfügung stehen.',
    connectCta: 'Verknüpfen',
    paidOnly: 'Nur in Solo / Team verfügbar',
    needUrl: 'Bitte eine Anbieter-URL einfügen.',
    previewFailed: 'Anbieter konnte nicht geladen werden.',
    loadAgents: 'Anbieter laden',
    foundAgents: '{{agentCount}} Makler · {{listingCount}} Inserate',
    pickYourName: 'Welcher Makler bist du?',
    suggested: 'Wahrscheinlich du',
    listingsShort: 'Ins.',
    pickAgentFirst: 'Bitte einen Makler auswählen.',
    saveBtn: 'Verknüpfen',
    saveFailed: 'Speichern fehlgeschlagen.',
    scopeHint: 'Wir importieren ab sofort nur Inserate dieses Maklers. Inserate von Kollegen unter demselben Anbieter werden ignoriert.',
    linked: 'Anbieter-Profil verknüpft.',
    scopedTo: 'Inserate von',
    disconnect: 'Trennen',
    confirmDisconnect: 'Anbieter-Profil wirklich trennen? Bereits importierte Inserate bleiben erhalten.',
    disconnected: 'Verbindung getrennt.',
    disconnectFailed: 'Trennen fehlgeschlagen.',
    rescanNow: 'Jetzt scannen',
    rescanning: 'Wird gescannt...',
    rescanFound: '{{count}} neue Inserate importiert.',
    rescanNoNew: 'Keine neuen Inserate gefunden.',
    rescanFailed: 'Scan fehlgeschlagen.',
    lastScan: 'Letzter Scan',
    neverScanned: 'noch nie',
    lastAddedCount: '{{count}} neue Inserate beim letzten Scan',
    noNewLast: 'Keine neuen Inserate beim letzten Scan',
    andMore: 'und {{count}} weitere',
    cronHint: 'Wir scannen täglich automatisch vor deinem Auto-Post nach neuen Inseraten. Neue Inserate werden im Vorschau-E-Mail erwähnt.',
  },
  quickEdit: {
    title: 'Immobiliendaten anpassen',
    intro: 'Diese Felder erscheinen im Video. Du kannst sie jederzeit anpassen. Bilder verwaltest du auf der Detailseite der Immobilie.',
    titleLabel: 'Titel',
    titleHelp: 'Headline + KI-Voiceover-Hook.',
    titleTooShort: 'Titel ist zu kurz.',
    priceLabel: 'Preis',
    locationLabel: 'Adresse',
    highlightsLabel: 'Highlights (mit Komma trennen)',
    descriptionLabel: 'Beschreibung',
    descriptionHelp: 'Wird vom KI-Voiceover als Grundlage verwendet. Kürzer + konkreter ist meistens besser.',
    saveBtn: 'Speichern',
    saved: 'Änderungen gespeichert.',
    saveFailed: 'Speichern fehlgeschlagen.',
  },
  teamInvite: {
    title: 'Team-Einladung',
    success: 'Willkommen im Team „{{team}}"!',
    successHelp: 'Du hast jetzt vollen Zugriff auf alle Real-Content-Funktionen über das Team-Abo.',
    toTeam: 'Zum Team',
    conflict: 'Diese Einladung kann nicht angenommen werden',
    conflictHelp: 'Du gehörst bereits zu einem Team. Verlasse es zuerst, oder kontaktiere den Inhaber.',
    failed: 'Einladung konnte nicht angenommen werden.',
    noToken: 'Kein gültiges Einladungs-Token in der URL. Wenn du den Link aus einer E-Mail geöffnet hast, ist er möglicherweise abgelaufen.',
  },
};

export default de;
